const dsaPatterns = {
    categories: {
      "Arrays & Strings": {
        sectionIcon: "📊",
        patternCount: 31,
        subcategories: {
          "Search in Sorted": {
            icon: "🔍",
            algorithms: {
              "Binary Search": {
                complexity: "O(log n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Efficiently searches sorted arrays by repeatedly dividing search space in half until target is found or space is exhausted.",
                howItWorks: "Compare target with middle element. If equal, found. If target is smaller, search left half. If larger, search right half. Repeat until found or search space exhausted.",
                whyUseIt: "Reduces time complexity from O(n) linear search to O(log n) by eliminating half the search space each iteration. Essential for efficient searching in sorted data.",
                useWhen: "Array is sorted, need O(log n) search, finding insertion point, search in rotated sorted arrays, peak finding.",
                keyPoints: "Watch for off-by-one errors with left/right boundaries. Use left + (right - left) // 2 to avoid overflow. Template: while left <= right for exact search, while left < right for range search.",
                codeExample: `def search_target(arr, target):
      left, right = 0, len(arr) - 1
      
      while left <= right:
          mid = left + (right - left) // 2
          
          if arr[mid] == target:
              return mid
          elif arr[mid] < target:
              left = mid + 1
          else:
              right = mid - 1
      
      return -1`
              }
            }
          },
          "Hash Table Operations": {
            icon: "🔗",
            algorithms: {
              "Hash Map/Set": {
                complexity: "O(1)",
                spaceComplexity: "O(n)",
                difficulty: 1,
                description: "Provides constant-time average lookup, insertion, and deletion using key-value mapping with hash functions.",
                howItWorks: "Hash function converts keys to array indices. Handles collisions via chaining or open addressing. Load factor determines when to resize the underlying array.",
                whyUseIt: "Transforms O(n) lookups into O(1) operations, essential for frequency counting and fast access patterns. Critical for optimizing nested loops.",
                useWhen: "Fast lookups needed, counting frequencies, checking existence, caching results, Two Sum problems, complement searching.",
                keyPoints: "Python dict/set are hash tables. Great for seen/visited tracking. Use defaultdict for cleaner counting. Watch for hash collisions in edge cases.",
                codeExample: `def find_pair(nums, target):
      seen = {}
      
      for i, num in enumerate(nums):
          complement = target - num
          
          if complement in seen:
              return [seen[complement], i]
          
          seen[num] = i
      
      return []`
              }
            }
          },
          "Pairs & k-Sum": {
            icon: "🤝",
            algorithms: {
              "Two Pointers": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Uses two pointers moving towards each other or in same direction to solve array problems without nested loops.",
                howItWorks: "Start pointers at different positions, move based on comparison with target or conditions. Reduces O(n²) to O(n) by eliminating redundant comparisons.",
                whyUseIt: "Eliminates need for nested loops in sorted arrays, naturally handles duplicates, space-efficient O(1) extra space. Essential for optimization.",
                useWhen: "Sorted array, Two Sum problems, palindrome validation, container with most water, removing duplicates, reversing arrays.",
                keyPoints: "Works great with sorted arrays. Move left pointer right if sum too small, right pointer left if sum too large. Simple but powerful technique.",
                codeExample: `def find_target_sum(nums, target):
      left, right = 0, len(nums) - 1
      
      while left < right:
          current_sum = nums[left] + nums[right]
          
          if current_sum == target:
              return [left, right]
          elif current_sum < target:
              left += 1
          else:
              right -= 1
      
      return []
  
  def check_symmetric(s):
      left, right = 0, len(s) - 1
      
      while left < right:
          if s[left] != s[right]:
              return False
          left += 1
          right -= 1
      
           return True`
              },
              "Three Sum": {              complexity: "O(n²)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds all unique triplets in array that sum to zero using two pointers technique with careful duplicate handling.",
                howItWorks: "Sort array, fix first element, use two pointers for remaining two. Skip duplicates at all three positions to ensure unique triplets.",
                whyUseIt: "Classic intermediate-level two pointers problem. Demonstrates duplicate handling and nested pointer management. Foundation for k-sum problems.",
                useWhen: "Three sum problems, k-sum variations, finding triplets with specific properties, duplicate handling in sorted arrays.",
                keyPoints: "Sort first for two pointers to work. Skip duplicates for first, second, and third elements. Time complexity O(n²) due to outer loop.",
                codeExample: `def find_triplets(nums):
      nums.sort()
      result = []
      
      for i in range(len(nums) - 2):
          # Skip duplicates for first element
          if i > 0 and nums[i] == nums[i-1]:
              continue
          
          left, right = i + 1, len(nums) - 1
          
          while left < right:
              current_sum = nums[i] + nums[left] + nums[right]
              
              if current_sum == 0:
                  result.append([nums[i], nums[left], nums[right]])
                  
                  # Skip duplicates for second element
                  while left < right and nums[left] == nums[left + 1]:
                      left += 1
                  # Skip duplicates for third element
                  while left < right and nums[right] == nums[right - 1]:
                      right -= 1
                  
                  left += 1
                  right -= 1
              elif current_sum < 0:
                  left += 1
              else:
                  right -= 1
      
      return result`
              },
              "Trapping Rain Water": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Calculates total rainwater that can be trapped between heights using two pointers to find water level at each position.",
                howItWorks: "Use left/right pointers with left_max/right_max tracking. Water level = min(left_max, right_max) - current_height.",
                whyUseIt: "Classic two-pointer optimization reducing O(n) space to O(1) while maintaining linear time complexity.",
                useWhen: "Trapping rainwater, container problems, finding valleys between peaks, histogram-based calculations.",
                keyPoints: "Move pointer with smaller max height. Water can only be trapped if surrounded by higher walls. Alternative: use stack for different approach.",
                codeExample: `def calculate_volume(height):
      if not height:
          return 0
      
      left, right = 0, len(height) - 1
      left_max = right_max = 0
      water = 0
      
      while left < right:
          if height[left] < height[right]:
              if height[left] >= left_max:
                  left_max = height[left]
              else:
                  water += left_max - height[left]
              left += 1
          else:
              if height[right] >= right_max:
                  right_max = height[right]
              else:
                  water += right_max - height[right]
              right -= 1
      
      return water`
              }
            }
          },
          "Subarray/Substring": {
            icon: "📏",
            algorithms: {
              "Sliding Window": {
                complexity: "O(n)",
                spaceComplexity: "O(k)",
                difficulty: 1,
                description: "Maintains a dynamic window of elements and slides it across array/string to find optimal subarray/substring efficiently.",
                howItWorks: "Two pointers (left/right) define window boundaries. Expand right to grow window, contract left to shrink when needed. Maintains running state as window slides.",
                whyUseIt: "Reduces nested loops from O(n²) to O(n) by reusing computation as window slides, maintaining running state. Critical for substring optimization.",
                useWhen: "Longest/shortest substring without repeating chars, minimum window substring, subarray with sum K, anagram problems, best time to buy/sell stock.",
                keyPoints: "Two types: fixed-size (move both pointers) and variable-size (expand right, contract left conditionally). Use hash map to track window state. Template: expand → process → contract when invalid.",
                codeExample: `def find_optimal_window(s):
      char_map = {}
      left = 0
      max_length = 0
      
      for right in range(len(s)):
          if s[right] in char_map and char_map[s[right]] >= left:
              left = char_map[s[right]] + 1
          
          char_map[s[right]] = right
          max_length = max(max_length, right - left + 1)
      
      return max_length`
              },
              "Kadane's Algorithm": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Finds maximum sum contiguous subarray in linear time using dynamic programming principles.",
                howItWorks: "At each position, decide whether to extend previous subarray or start fresh. Track running sum and global maximum.",
                whyUseIt: "Solves classic maximum subarray problem efficiently. Core insight: negative running sums only hurt future subarrays.",
                useWhen: "Maximum subarray sum, maximum product subarray (modified), stock profit problems, any contiguous optimization problem.",
                keyPoints: "Reset running sum to current element if sum becomes smaller. Key decision: max(current_element, running_sum + current_element). Works with all negative arrays too.",
                codeExample: `def find_maximum_sum(nums):
      max_ending_here = max_so_far = nums[0]
      
      for i in range(1, len(nums)):
          max_ending_here = max(nums[i], max_ending_here + nums[i])
          max_so_far = max(max_so_far, max_ending_here)
      
      return max_so_far`
              },
              "Maximum Product Subarray": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds maximum product contiguous subarray handling negative numbers by tracking both max and min products.",
                howItWorks: "Maintain max_so_far and min_so_far since negative × negative = positive. Swap max/min when current is negative.",
                whyUseIt: "Variation of Kadane's that handles the complexity where negative numbers can create larger products.",
                useWhen: "Maximum product subarray, handling arrays with negative numbers, stock price variations with positive/negative changes.",
                keyPoints: "Track both max and min products. When current element is negative, swap max and min before calculation. Handle zero by resetting both max and min.",
                codeExample: `def find_maximum_product(nums):
      if not nums:
          return 0
      
      max_so_far = min_so_far = result = nums[0]
      
      for i in range(1, len(nums)):
          current = nums[i]
          
          if current < 0:
              max_so_far, min_so_far = min_so_far, max_so_far
          
          max_so_far = max(current, max_so_far * current)
          min_so_far = min(current, min_so_far * current)
          
          result = max(result, max_so_far)
      
      return result`
              },
              "Prefix Sum": {              complexity: "O(n)",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Precomputes cumulative sums from start to each position, enabling constant-time range sum queries.",
                howItWorks: "prefix[i] = sum of elements from index 0 to i. Range sum = prefix[right] - prefix[left-1].",
                whyUseIt: "Transforms O(n) range queries to O(1), essential when multiple range calculations needed.",
                useWhen: "Multiple range sum queries, subarray sum equals K, range queries on immutable arrays, 2D matrix sums.",
                keyPoints: "Build once, query many times. Add dummy 0 at start to simplify edge cases. For subarray sum K: use prefix[j] - prefix[i] = K → prefix[j] - K = prefix[i].",
                codeExample: `def build_cumulative(arr):
      prefix = [0] * (len(arr) + 1)
      for i in range(len(arr)):
          prefix[i + 1] = prefix[i] + arr[i]
      return prefix
  
  def query_range(prefix, left, right):
      return prefix[right + 1] - prefix[left]`
              },
              "Product of Array Except Self": {              complexity: "O(n)",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Calculates product of all elements except self for each position without using division operator.",
                howItWorks: "Two passes - first for left products, second for right products. Multiply them to get final result.",
                whyUseIt: "Avoids division operator and handles zero values correctly. Classic array manipulation pattern.",
                useWhen: "Product calculations, array transformations, avoiding division, handling zeros in products.",
                keyPoints: "Use two passes: left products then right products. Can optimize space to O(1) by using output array for left products. Handle zeros properly.",
                codeExample: `def calculate_products(nums):
      n = len(nums)
      result = [1] * n
      
      for i in range(1, n):
          result[i] = result[i-1] * nums[i-1]
      
      right_product = 1
      for i in range(n-1, -1, -1):
          result[i] *= right_product
          right_product *= nums[i]
      
      return result`
              }
            }
          },
          "Array Manipulation": {
            icon: "🔄",
            algorithms: {
              "Rotate Array": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Rotates array elements to the right by k steps using reversal technique or cyclic replacements.",
                howItWorks: "Three approaches: extra array O(n) space, cyclic replacements, or reverse array technique (reverse all, reverse first k, reverse rest).",
                whyUseIt: "Common array manipulation problem with elegant solutions. Tests understanding of in-place algorithms and modular arithmetic.",
                useWhen: "Array rotation problems, circular array operations, shifting elements, implementing circular buffers.",
                keyPoints: "Use k % n to handle k > n. Reverse technique: reverse all → reverse first k → reverse remaining. Handle edge cases like empty array.",
                codeExample: `def shift_elements(nums, k):
      n = len(nums)
      k = k % n
      
      def reverse(start, end):
          while start < end:
              nums[start], nums[end] = nums[end], nums[start]
              start += 1
              end -= 1
      
      reverse(0, n - 1)      # Reverse entire array
      reverse(0, k - 1)      # Reverse first k elements  
      reverse(k, n - 1)      # Reverse remaining elements`
              },
              "Find Duplicate Number": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Finds the duplicate number in an array containing n+1 integers where each integer is between 1 and n using Floyd's cycle detection.",
                howItWorks: "Use Floyd's cycle detection algorithm. Treat array as linked list where nums[i] points to nums[nums[i]]. Duplicate creates cycle.",
                whyUseIt: "Elegant application of cycle detection to array problems. Achieves O(1) space without modifying array.",
                useWhen: "Finding duplicates with space constraints, cycle detection in arrays, mathematical problem solving.",
                keyPoints: "Apply Floyd's algorithm to arrays. Slow/fast pointers find cycle. Second phase finds cycle start (duplicate). Don't modify original array.",
                codeExample: `def find_repeated_value(nums):
      slow = fast = nums[0]
      
      # Phase 1: Find intersection point in cycle
      while True:
          slow = nums[slow]
          fast = nums[nums[fast]]
          if slow == fast:
              break
      
      # Phase 2: Find entrance to cycle (duplicate)
      slow = nums[0]
      while slow != fast:
          slow = nums[slow]
          fast = nums[fast]
      
      return slow`
              }
            }
          },
          "String Matching": {
            icon: "🔤",
            algorithms: {
              "Trie (Prefix Tree)": {
                complexity: "O(m)",
                spaceComplexity: "O(ALPHABET_SIZE * N * M)",
                difficulty: 2,
                description: "Tree-like data structure for storing strings with shared prefixes, enabling ultra-fast prefix operations and word searches.",
                howItWorks: "Each node represents a character, path from root to leaf forms complete word. Shared prefixes reuse same nodes.",
                whyUseIt: "O(m) search/insert regardless of dictionary size. Essential for autocomplete, spell checkers, word games.",
                useWhen: "Autocomplete systems, word search puzzles, prefix matching, dictionary operations, IP routing, replacing words with roots.",
                keyPoints: "Each node stores children as dictionary/array. Mark word endings with boolean flag. Space-time tradeoff: faster queries but more memory usage. Perfect for word-based problems.",
                codeExample: `class TrieNode:
      def __init__(self):
          self.children = {}
          self.is_end_word = False
  
  class Trie:
      def __init__(self):
          self.root = TrieNode()
      
      def insert(self, word):
          node = self.root
          for char in word:
              if char not in node.children:
                  node.children[char] = TrieNode()
              node = node.children[char]
          node.is_end_word = True
      
      def search(self, word):
          node = self.root
          for char in word:
              if char not in node.children:
                  return False
              node = node.children[char]
          return node.is_end_word`
              },
              "KMP Algorithm": {
                complexity: "O(n+m)",
                spaceComplexity: "O(m)",
                difficulty: 2,
                description: "Advanced string matching algorithm that finds pattern in text without redundant character comparisons using preprocessing.",
                howItWorks: "Builds LPS (Longest Prefix Suffix) array to track how much of pattern matches itself. Uses this to skip comparisons.",
                whyUseIt: "Improves naive O(nm) string matching to O(n+m). Essential for large text processing and pattern detection.",
                useWhen: "Pattern matching in large texts, finding all occurrences, string searching with repeated patterns, text editors, DNA sequence analysis.",
                keyPoints: "Two phases: build LPS array O(m), then search O(n). LPS[i] = length of longest prefix that's also suffix. When mismatch occurs, use LPS to avoid re-scanning text.",
                codeExample: `def optimized_pattern_search(text, pattern):
      def build_failure_function(pattern):
          lps = [0] * len(pattern)
          length = 0
          i = 1
          
          while i < len(pattern):
              if pattern[i] == pattern[length]:
                  length += 1
                  lps[i] = length
                  i += 1
              else:
                  if length != 0:
                      length = lps[length - 1]
                  else:
                      lps[i] = 0
                      i += 1
          return lps
      
      lps = build_failure_function(pattern)
      result = []
      i = j = 0
      
      while i < len(text):
          if pattern[j] == text[i]:
              i += 1
              j += 1
          
          if j == len(pattern):
              result.append(i - j)
              j = lps[j - 1]
          elif i < len(text) and pattern[j] != text[i]:
              if j != 0:
                  j = lps[j - 1]
              else:
                  i += 1
      
      return result`
              },
              "Boyer-Moore Algorithm": {
                complexity: "O(nm) worst, O(n/m) best",
                spaceComplexity: "O(m + σ)",
                difficulty: 3,
                description: "Advanced string matching algorithm that searches from right to left and can skip many characters on mismatch.",
                howItWorks: "Uses bad character and good suffix heuristics. Scans pattern from right to left, uses character tables to skip positions.",
                whyUseIt: "Very fast in practice, especially for large alphabets. Can be sublinear in best case. Used in text editors like grep.",
                useWhen: "Large text search, text editors, when alphabet size is large, preprocessing time is acceptable.",
                keyPoints: "Two heuristics: bad character (char not in pattern) and good suffix (matched suffix). Preprocessing creates lookup tables. Best for large alphabets.",
                codeExample: `def advanced_string_search(text, pattern):
      def build_char_table(pattern):
          table = {}
          for i in range(len(pattern)):
              table[pattern[i]] = i
          return table
      
      bad_char = build_char_table(pattern)
      result = []
      shift = 0
      
      while shift <= len(text) - len(pattern):
          j = len(pattern) - 1
          
          while j >= 0 and pattern[j] == text[shift + j]:
              j -= 1
          
          if j < 0:
              result.append(shift)
              shift += len(pattern) - bad_char.get(text[shift + len(pattern)], -1) - 1 if shift + len(pattern) < len(text) else 1
          else:
              shift += max(1, j - bad_char.get(text[shift + j], -1))
      
      return result`
              },
              "Z Algorithm": {
                complexity: "O(n)",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Linear time string matching algorithm that computes Z-array where Z[i] is length of longest substring starting from i which is also prefix.",
                howItWorks: "Maintains window [L,R] of rightmost segment that matches prefix. Uses previously computed values to optimize computation.",
                whyUseIt: "Linear time string matching with elegant implementation. Useful for multiple pattern matching problems.",
                useWhen: "Pattern matching, finding all occurrences, palindrome problems, string analysis, when need all prefix matches.",
                keyPoints: "Z[i] = length of longest substring starting at i that matches prefix. Maintains window optimization. Simpler than KMP for some problems.",
                codeExample: `def build_prefix_array(s):
      n = len(s)
      z = [0] * n
      l = r = 0
      
      for i in range(1, n):
          if i <= r:
              z[i] = min(r - i + 1, z[i - l])
          
          while i + z[i] < n and s[z[i]] == s[i + z[i]]:
              z[i] += 1
          
          if i + z[i] - 1 > r:
              l = i
              r = i + z[i] - 1
      
      return z
  
  def pattern_search(text, pattern):
      combined = pattern + "$" + text
      z = build_prefix_array(combined)
      result = []
      
      for i in range(len(pattern) + 1, len(combined)):
          if z[i] == len(pattern):
              result.append(i - len(pattern) - 1)
      
      return result`
              },
              "Rabin-Karp Algorithm": {
                complexity: "O(nm) worst, O(n+m) average",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "String matching algorithm using rolling hash to find pattern occurrences, good for multiple pattern search.",
                howItWorks: "Computes hash of pattern, then rolls hash through text. When hashes match, verify with character comparison.",
                whyUseIt: "Good average case performance, excellent for searching multiple patterns simultaneously, simple to implement.",
                useWhen: "Multiple pattern search, plagiarism detection, when simple implementation preferred, hash-based problems.",
                keyPoints: "Rolling hash avoids recomputing from scratch. Choose good hash function and modulus. Hash collision requires character verification.",
                codeExample: `def rolling_hash_search(text, pattern):
      d = 256  # number of characters
      q = 101  # prime number
      
      m = len(pattern)
      n = len(text)
      p = 0  # hash value for pattern
      t = 0  # hash value for text
      h = 1
      result = []
      
      # Calculate h = pow(d, m-1) % q
      for i in range(m - 1):
          h = (h * d) % q
      
      # Calculate hash for pattern and first window
      for i in range(m):
          p = (d * p + ord(pattern[i])) % q
          t = (d * t + ord(text[i])) % q
      
      # Slide pattern over text
      for i in range(n - m + 1):
          if p == t:
              # Check characters one by one
              match = True
              for j in range(m):
                  if text[i + j] != pattern[j]:
                      match = False
                      break
              if match:
                  result.append(i)
          
          # Calculate hash for next window
          if i < n - m:
              t = (d * (t - ord(text[i]) * h) + ord(text[i + m])) % q
              if t < 0:
                  t += q
      
      return result`
              },
              "Manacher's Algorithm": {
                complexity: "O(n)",
                spaceComplexity: "O(n)",
                difficulty: 3,
                description: "Linear time algorithm to find all palindromic substrings by transforming string and using center expansion with optimization.",
                howItWorks: "Transform string by inserting special characters, then use symmetry property to avoid redundant checks when expanding around centers.",
                whyUseIt: "Finds all palindromic substrings in linear time, much faster than naive O(n³) or expand-around-center O(n²) approaches.",
                useWhen: "Finding all palindromes, longest palindromic substring problems, palindrome counting, advanced string processing.",
                keyPoints: "Transform string first (e.g., 'aba' -> '#a#b#a#'). Use previously computed palindrome info to optimize expansion. Maintains center and right boundary.",
                codeExample: `def find_all_palindromes(s):
      # Transform string: "abc" -> "#a#b#c#"
      transformed = '#'.join('^{}$'.format(s))
      n = len(transformed)
      p = [0] * n  # palindrome lengths
      center = right = 0
      
      for i in range(1, n - 1):
          mirror = 2 * center - i
          
          if i < right:
              p[i] = min(right - i, p[mirror])
          
          # Try to expand palindrome centered at i
          while transformed[i + (1 + p[i])] == transformed[i - (1 + p[i])]:
              p[i] += 1
          
          # If palindrome centered at i extends past right, adjust center and right
          if i + p[i] > right:
              center = i
              right = i + p[i]
      
      # Find longest palindrome
      max_len = 0
      center_index = 0
      for i in range(1, n - 1):
          if p[i] > max_len:
              max_len = p[i]
              center_index = i
      
      start = (center_index - max_len) // 2
      return s[start:start + max_len]`
              }
            }
          },
          "Advanced Array Algorithms": {
            icon: "🧮",
            algorithms: {
              "Dutch National Flag": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Three-way partitioning algorithm that sorts array containing only 0s, 1s, and 2s in a single pass.",
                howItWorks: "Uses three pointers: low (next position for 0), mid (current element), high (next position for 2). Swaps elements to correct positions.",
                whyUseIt: "Efficiently solves 3-way partitioning in linear time with constant space. Classic example of multiple pointer technique.",
                useWhen: "Sorting arrays with 3 distinct values, partitioning problems, color sorting, categorical data organization.",
                keyPoints: "Three pointers technique. Process mid pointer, swap 0s to low region, 2s to high region. Keep 1s in middle naturally.",
                codeExample: `def partition_three_way(nums):
      low = mid = 0
      high = len(nums) - 1
      
      while mid <= high:
          if nums[mid] == 0:
              nums[low], nums[mid] = nums[mid], nums[low]
              low += 1
              mid += 1
          elif nums[mid] == 1:
              mid += 1
          else:  # nums[mid] == 2
              nums[mid], nums[high] = nums[high], nums[mid]
              high -= 1
              # Don't increment mid here as we need to check swapped element`
              },
              "Next Permutation": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds the lexicographically next greater permutation of numbers by finding rightmost ascending pair and rearranging.",
                howItWorks: "Find rightmost character smaller than next, find smallest character to its right that's larger, swap them, reverse suffix.",
                whyUseIt: "Essential algorithm for generating permutations in lexicographical order. Used in combinatorial problems and optimization.",
                useWhen: "Generating permutations, combinatorial problems, optimization algorithms, lexicographical ordering.",
                keyPoints: "Find pivot (rightmost i where nums[i] < nums[i+1]), find successor, swap, reverse suffix. If no pivot, reverse entire array.",
                codeExample: `def find_next_arrangement(nums):
      # Find the pivot point
      i = len(nums) - 2
      while i >= 0 and nums[i] >= nums[i + 1]:
          i -= 1
      
      if i >= 0:
          # Find the rightmost character greater than pivot
          j = len(nums) - 1
          while nums[j] <= nums[i]:
              j -= 1
          
          # Swap pivot with successor
          nums[i], nums[j] = nums[j], nums[i]
      
      # Reverse the suffix
      nums[i + 1:] = nums[i + 1:][::-1]`
              },
              "Moore's Voting Algorithm": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds majority element (appears more than n/2 times) in array using cancellation technique.",
                howItWorks: "Maintain candidate and count. Increment count for same element, decrement for different. When count is 0, update candidate.",
                whyUseIt: "Elegantly solves majority element problem in linear time with constant space, avoiding need for sorting or hash maps.",
                useWhen: "Finding majority element, voting systems, stream processing, when need constant space solution.",
                keyPoints: "Based on cancellation - majority element will survive all cancellations. Requires second pass to verify if guaranteed majority doesn't exist.",
                codeExample: `def find_dominant_element(nums):
      candidate = count = 0
      
      # Phase 1: Find candidate
      for num in nums:
          if count == 0:
              candidate = num
          count += (1 if num == candidate else -1)
      
      # Phase 2: Verify candidate (optional if majority guaranteed)
      count = sum(1 for num in nums if num == candidate)
      return candidate if count > len(nums) // 2 else None`
              },
              "Container With Most Water": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds two lines that form container holding maximum water using two pointers from ends moving toward center.",
                howItWorks: "Start with widest container (endpoints), move pointer with smaller height inward since that's the bottleneck.",
                whyUseIt: "Classic two-pointer optimization problem. Demonstrates greedy choice and elimination of suboptimal solutions.",
                useWhen: "Two-pointer problems, geometric optimization, maximization problems with constraints.",
                keyPoints: "Always move pointer with smaller height. Width decreases but height might increase. Area = min(height[left], height[right]) * (right - left).",
                codeExample: `def find_maximum_area(height):
      left, right = 0, len(height) - 1
      max_water = 0
      
      while left < right:
          width = right - left
          current_water = min(height[left], height[right]) * width
          max_water = max(max_water, current_water)
          
          if height[left] < height[right]:
              left += 1
          else:
              right -= 1
      
      return max_water`
              },
              "First Missing Positive": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 3,
                description: "Finds the smallest missing positive integer in unsorted array using cyclic sort technique without extra space.",
                howItWorks: "Use array indices as hash table. Place each positive number x at index x-1. Scan to find first missing position.",
                whyUseIt: "Clever use of input array as hash table. Solves classic problem with optimal time/space complexity.",
                useWhen: "Missing number problems, when can't use extra space, cyclic sort variations, array transformation problems.",
                keyPoints: "Use input array as hash table. Only care about numbers in range [1, n]. Place number x at index x-1.",
                codeExample: `def find_smallest_missing(nums):
      n = len(nums)
      
      # Place each positive number at its correct position
      for i in range(n):
          while 1 <= nums[i] <= n and nums[nums[i] - 1] != nums[i]:
              # Swap current number to its correct position
              correct_pos = nums[i] - 1
              nums[i], nums[correct_pos] = nums[correct_pos], nums[i]
      
      # Find the first missing positive
      for i in range(n):
          if nums[i] != i + 1:
              return i + 1
      
      return n + 1`
              }
            }
          },
          "String Validation & Grouping": {
            icon: "🔤",
            algorithms: {
              "Valid Anagram": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Determines if two strings are anagrams by checking if they contain the same characters with the same frequencies.",
                howItWorks: "Count character frequencies in both strings using hash map or array (for ASCII). Compare frequency maps or use sorting approach.",
                whyUseIt: "Fundamental string problem testing character frequency analysis. Building block for more complex anagram problems. Essential for hash map practice.",
                useWhen: "Anagram detection, character frequency analysis, string comparison, word games, spell checkers, text analysis tools.",
                keyPoints: "Use character frequency counting. Early exit if lengths differ. Can sort strings or use hash map. Consider Unicode vs ASCII constraints.",
                codeExample: `def isAnagram(s, t):
      if len(s) != len(t):
          return False
      
      char_count = {}
      
      for char in s:
          char_count[char] = char_count.get(char, 0) + 1
      
      for char in t:
          if char not in char_count:
              return False
          char_count[char] -= 1
          if char_count[char] == 0:
              del char_count[char]
      
      return len(char_count) == 0`
              },
              "Group Anagrams": {              complexity: "O(n * k log k)",
                spaceComplexity: "O(n*m)",
                difficulty: 1,
                description: "Groups strings that are anagrams of each other using sorted string as key or character frequency counting.",
                howItWorks: "Use sorted string as hash map key to group anagrams, or create frequency signature. All anagrams will have same sorted form or frequency pattern.",
                whyUseIt: "Practical application of anagram detection with grouping. Demonstrates hash map usage for categorization. Common in word processing applications.",
                useWhen: "Word grouping, anagram categorization, text processing, word games, dictionary organization, language analysis tools.",
                keyPoints: "Sort each string to create consistent key. Use defaultdict for cleaner code. Alternative: create frequency tuple as key. Return list of lists.",
                codeExample: `from collections import defaultdict
  
  def groupAnagrams(strs):
      anagram_groups = defaultdict(list)
      
      for s in strs:
          # Use sorted string as key
          key = ''.join(sorted(s))
          anagram_groups[key].append(s)
      
      return list(anagram_groups.values())`
              }
            }
          },
          "String Processing": {
            icon: "📝",
            algorithms: {
              "Valid Parentheses": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Determines if a string containing only parentheses characters is valid by ensuring all brackets are properly closed and in correct order.",
                howItWorks: "Use stack to track opening brackets. For each opening bracket, push to stack. For each closing bracket, check if it matches the most recent opening bracket.",
                whyUseIt: "Fundamental stack problem. Tests understanding of bracket matching and stack operations. Essential for expression parsing and syntax validation.",
                useWhen: "Bracket matching, expression validation, syntax parsing, code validation, mathematical expression checking, compiler design.",
                keyPoints: "Use stack for matching pairs. Push opening brackets, pop and check for closing brackets. Stack should be empty at end for valid string.",
                codeExample: `def isValid(s):
      stack = []
      mapping = {')': '(', '}': '{', ']': '['}
      
      for char in s:
          if char in mapping:
              if not stack or stack.pop() != mapping[char]:
                  return False
          else:
              stack.append(char)
      
      return not stack`
              },
              "Longest Palindromic Substring": {              complexity: "O(n²)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds the longest contiguous substring that reads the same forwards and backwards using center expansion technique.",
                howItWorks: "For each possible center (character or between characters), expand outwards while characters match. Track the longest palindrome found.",
                whyUseIt: "Classic string processing problem. Demonstrates center expansion technique. More efficient than brute force O(n³) approach.",
                useWhen: "Palindrome detection, string processing, pattern matching, text analysis, DNA sequence analysis, compression algorithms.",
                keyPoints: "Consider both odd-length (center is character) and even-length (center is between characters) palindromes. Expand around center technique is O(n²).",
                codeExample: `def longestPalindrome(s):
      if not s:
          return ""
      
      start = 0
      max_len = 1
      
      def expand_around_center(left, right):
          while left >= 0 and right < len(s) and s[left] == s[right]:
              left -= 1
              right += 1
          return right - left - 1
      
      for i in range(len(s)):
          # Odd length palindromes
          len1 = expand_around_center(i, i)
          # Even length palindromes  
          len2 = expand_around_center(i, i + 1)
          
          current_max = max(len1, len2)
          if current_max > max_len:
              max_len = current_max
              start = i - (current_max - 1) // 2
      
      return s[start:start + max_len]`
              },
              "Longest Substring Without Repeating Characters": {              complexity: "O(n)",
                spaceComplexity: "O(min(m,n))",
                difficulty: 1,
                description: "Finds the length of the longest substring without repeating characters using sliding window technique with hash map.",
                howItWorks: "Use sliding window with hash map to track character positions. Expand right pointer and contract left pointer when duplicate found.",
                whyUseIt: "Classic sliding window problem. Demonstrates hash map usage with two pointers. Optimal O(n) solution vs brute force O(n³).",
                useWhen: "Substring problems, sliding window practice, character tracking, streaming data analysis, text processing optimization.",
                keyPoints: "Sliding window technique with hash map. Track character positions. Move left pointer to position after duplicate. Update max length continuously.",
                codeExample: `def lengthOfLongestSubstring(s):
      char_map = {}
      left = 0
      max_length = 0
      
      for right in range(len(s)):
          if s[right] in char_map and char_map[s[right]] >= left:
              left = char_map[s[right]] + 1
          
          char_map[s[right]] = right
          max_length = max(max_length, right - left + 1)
      
      return max_length`
              },
              "Longest Repeating Character Replacement": {
                complexity: "O(n)",
                spaceComplexity: "O(k)",
                difficulty: 2,
                description: "Finds the longest substring containing the same letter after replacing at most k characters using sliding window with frequency tracking.",
                howItWorks: "Use sliding window with character frequency map. Expand right pointer and track the most frequent character. Contract left pointer when window size minus max frequency exceeds k replacements.",
                whyUseIt: "Optimizes character replacement problems using sliding window. Efficiently handles variable window size based on replacement budget. Key insight: only need to track the maximum frequency seen so far.",
                useWhen: "String transformation problems, character replacement with budget, longest valid substring with modifications, sliding window with constraints.",
                keyPoints: "Track character frequencies in current window. Key insight: max_found doesn't need to decrease when shrinking window. Window is valid when (window_size - max_frequency) <= k. Efficient O(n) solution using two pointers.",
                codeExample: `def characterReplacement(s, k):
      seen = {}
      longest = 0
      left = 0
      max_found = 0

      for right in range(len(s)):
          seen[s[right]] = seen.get(s[right], 0) + 1
          max_found = max(max_found, seen[s[right]])

          while k < (right - left + 1) - max_found:
              seen[s[left]] -= 1
              left += 1

          longest = max(longest, right - left + 1)

      return longest`
              }
            }
          },
          "Sorting Algorithms": {
            icon: "📶",
            algorithms: {
              "Merge Sort": {
                complexity: "O(n log n)",
                spaceComplexity: "O(n)",
                difficulty: 1,
                description: "Stable divide-and-conquer sorting algorithm that consistently performs in O(n log n) time regardless of input distribution.",
                howItWorks: "Recursively divide array into halves until single elements, then merge sorted halves back together using two pointers to maintain sorted order.",
                whyUseIt: "Guaranteed O(n log n) performance, stable sorting, works well with linked lists, predictable performance regardless of input.",
                useWhen: "Need stable sort, sorting linked lists, guaranteed performance, large datasets, external sorting, when worst-case matters.",
                keyPoints: "Divide and conquer approach. Stable sort preserves relative order. Always O(n log n) time. Uses O(n) extra space. Great for linked lists.",
                codeExample: `def divide_and_conquer_sort(arr):
      if len(arr) <= 1:
          return arr
      
      mid = len(arr) // 2
      left = divide_and_conquer_sort(arr[:mid])
      right = divide_and_conquer_sort(arr[mid:])
      
      return combine_arrays(left, right)
  
  def combine_arrays(left, right):
      result = []
      i = j = 0
      
      while i < len(left) and j < len(right):
          if left[i] <= right[j]:
              result.append(left[i])
              i += 1
          else:
              result.append(right[j])
              j += 1
      
      result.extend(left[i:])
      result.extend(right[j:])
      return result`
              },
              "Quick Sort": {
                complexity: "O(n log n)",
                spaceComplexity: "O(log n)",
                difficulty: 2,
                description: "Efficient in-place divide-and-conquer sorting algorithm with average O(n log n) performance but O(n²) worst case.",
                howItWorks: "Choose pivot, partition array so elements smaller than pivot are left, larger are right. Recursively sort partitions.",
                whyUseIt: "Very fast average case, in-place sorting (O(1) extra space), cache-friendly, widely used in practice.",
                useWhen: "General purpose sorting, when average case performance matters, memory is limited, randomized input expected.",
                keyPoints: "Pivot selection affects performance. Worst case O(n²) with bad pivots. Average case O(n log n). In-place sorting. Not stable.",
                codeExample: `def partition_sort(arr, low=0, high=None):
      if high is None:
          high = len(arr) - 1
      
      if low < high:
          pivot_index = split_array(arr, low, high)
          partition_sort(arr, low, pivot_index - 1)
          partition_sort(arr, pivot_index + 1, high)
  
  def split_array(arr, low, high):
      pivot = arr[high]
      i = low - 1
      
      for j in range(low, high):
          if arr[j] <= pivot:
              i += 1
              arr[i], arr[j] = arr[j], arr[i]
      
      arr[i + 1], arr[high] = arr[high], arr[i + 1]
      return i + 1`
              }
            }
          }
        }
      },
      "Linked Lists": {
        sectionIcon: "🔗",
        patternCount: 13,
        subcategories: {
          "Fast & Slow Pointers": {
            icon: "🏃‍♂️",
            algorithms: {
              "Cycle Detection": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Uses two pointers (slow and fast) moving at different speeds to detect cycles, find middle nodes, and solve pointer-based problems in linked lists.",
                howItWorks: "Slow pointer moves one step, fast pointer moves two steps. If there's a cycle, fast will eventually meet slow. For middle finding, when fast reaches end, slow is at middle.",
                whyUseIt: "Detects cycles in O(n) time with O(1) space. Elegant solution using mathematical properties of cycle detection. No need for extra data structures.",
                useWhen: "Detecting cycles, finding middle node, removing nth node from end, detecting intersection points, happy number problems.",
                keyPoints: "Fast catches up to slow in cycles due to speed difference. Distance between pointers increases by 1 each iteration. When fast reaches end, slow is at middle for odd-length lists.",
                codeExample: `def detect_loop(head):
      if not head or not head.next:
          return False
      
      slow = fast = head
      while fast and fast.next:
          slow = slow.next
          fast = fast.next.next
          if slow == fast:
              return True
      return False
  
  def find_center(head):
      slow = fast = head
      while fast and fast.next:
          slow = slow.next
          fast = fast.next.next
      return slow`
              },
              "Find Cycle Start (Floyd's Two-Phase)": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Uses Floyd's two-phase cycle detection algorithm to find the exact node where a cycle begins in a linked list, combining cycle detection with mathematical proof.",
                howItWorks: "Phase 1: Use fast/slow pointers to detect cycle existence. Phase 2: Reset slow to head, move both pointers one step until they meet at cycle start. Mathematical proof: distance from head to cycle start equals remaining cycle distance.",
                whyUseIt: "Finds cycle start in O(n) time with O(1) space. Elegant mathematical solution that avoids hash sets. Essential for advanced linked list problems and demonstrates beautiful algorithmic proof.",
                useWhen: "Finding cycle start position, Linked List Cycle II problems, detecting where corruption begins, advanced cycle analysis, interview problems requiring cycle start.",
                keyPoints: "Two phases: detect cycle, then find start. Mathematical insight: a = c (head-to-start = remaining cycle). Reset slow to head after first meeting. Both pointers move one step in phase 2.",
                codeExample: `def find_loop_start(head):
      if not head or not head.next:
          return None
      
      # Phase 1: Detect cycle
      slow = fast = head
      while fast and fast.next:
          slow = slow.next
          fast = fast.next.next
          if slow == fast:
              break
      else:
          return None  # No cycle found
      
      # Phase 2: Find cycle start
      slow = head
      while slow != fast:
          slow = slow.next
          fast = fast.next
      
      return slow  # Cycle start node`
              },
              "Happy Number (Cycle Detection)": {              complexity: "O(log n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Applies Floyd's cycle detection algorithm to mathematical sequences to determine if a number eventually becomes 1 (happy) or enters an infinite cycle.",
                howItWorks: "Use slow/fast pointers on sum of squares sequence. Slow computes one iteration, fast computes two. If they meet and neither is 1, there's a cycle.",
                whyUseIt: "Elegant application of cycle detection to mathematical problems. Avoids using sets or additional memory by leveraging pointer technique properties.",
                useWhen: "Happy number detection, any sequence that may cycle, mathematical cycle problems, detecting repetitive patterns in calculations.",
                keyPoints: "Apply linked list techniques to mathematical sequences. Sum of squares creates deterministic sequence. Eventually cycles or reaches 1. Fast/slow pointer detects cycles efficiently.",
                codeExample: `def isHappy(n):
      def get_sum_of_squares(num):
          total = 0
          while num > 0:
              digit = num % 10
              total += digit * digit
              num //= 10
          return total
      
      slow = fast = n
      
      while True:
          slow = get_sum_of_squares(slow)
          fast = get_sum_of_squares(get_sum_of_squares(fast))
          
          if fast == 1:
              return True
          if slow == fast:
              return False`
              }
            }
          },
          "Linked List Manipulation": {
            icon: "⚙️",
            algorithms: {
              "Reverse Linked List": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Reverses the direction of pointers in a linked list, effectively changing the order of nodes from original sequence to reversed sequence.",
                howItWorks: "Use three pointers (prev, current, next) to iteratively reverse links. Or use recursion to reverse from tail back to head.",
                whyUseIt: "Fundamental linked list operation. Essential building block for many complex linked list problems. Can be done in O(n) time and O(1) space.",
                useWhen: "Reversing entire list, reversing between positions, palindrome checking, reversing k-group nodes, implementing undo functionality.",
                keyPoints: "Three-pointer technique: prev, current, next. Save next before breaking link. Recursive solution uses O(n) stack space. Handle edge cases like empty list.",
                codeExample: `def flip_direction(head):
      prev = None
      current = head
      
      while current:
          next_temp = current.next
          current.next = prev
          prev = current
          current = next_temp
      
      return prev`
              },
              "Reverse Linked List II": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Reverses nodes between positions left and right in a linked list, keeping the rest of the list intact.",
                howItWorks: "Find the start position, reverse the sublist between left and right, then reconnect with original list parts.",
                whyUseIt: "More advanced reversal technique that demonstrates partial list manipulation while maintaining connections.",
                useWhen: "Reversing sublists, partial data reversal, maintaining list integrity during operations, advanced linked list problems.",
                keyPoints: "Use dummy node for edge cases. Track connections before and after reversed section. Reverse only the specified range.",
                codeExample: `def reverseBetween(head, left, right):
      dummy = ListNode(0)
      dummy.next = head
      prev = dummy
      
      # Move to position before left
      for _ in range(left - 1):
          prev = prev.next
      
      # Reverse between left and right
      current = prev.next
      for _ in range(right - left):
          next_node = current.next
          current.next = next_node.next
          next_node.next = prev.next
          prev.next = next_node
      
      return dummy.next`
              },
              "Remove Nth Node from End": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Removes the nth node from the end of a linked list in one pass using two pointers separated by n positions.",
                howItWorks: "Use dummy node to handle edge cases. Move fast pointer n+1 steps ahead, then move both pointers until fast reaches end. Slow pointer will be at node before target.",
                whyUseIt: "Classic two-pointer technique for linked lists. Solves in one pass without knowing list length. Essential for understanding pointer manipulation.",
                useWhen: "Removing nodes from end, maintaining gap between pointers, one-pass linked list algorithms, avoiding multiple traversals.",
                keyPoints: "Use dummy node for edge cases (removing head). Fast pointer moves n+1 steps ahead. When fast reaches end, slow is at node before target.",
                codeExample: `def removeNthFromEnd(head, n):
      dummy = ListNode(0)
      dummy.next = head
      fast = slow = dummy
      
      # Move fast n+1 steps ahead
      for _ in range(n + 1):
          fast = fast.next
      
      # Move both until fast reaches end
      while fast:
          fast = fast.next
          slow = slow.next
      
      # Skip the nth node from end
      slow.next = slow.next.next
      return dummy.next`
              },
              "Remove Duplicates": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Removes duplicate nodes from a sorted linked list, keeping only unique values or the first occurrence of each value.",
                howItWorks: "Traverse the list comparing current with next node. If values match, skip the duplicate node by adjusting pointers.",
                whyUseIt: "Common list processing operation. Demonstrates pointer manipulation and conditional node removal techniques.",
                useWhen: "Data deduplication, processing sorted lists, maintaining unique elements, data cleaning operations.",
                keyPoints: "Works on sorted lists. Compare current.val with current.next.val. Skip duplicates by adjusting next pointer. Handle edge cases.",
                codeExample: `def deleteDuplicates(head):
      current = head
      
      while current and current.next:
          if current.val == current.next.val:
              current.next = current.next.next
          else:
              current = current.next
      
      return head`
              }
            }
          },
          "Merge Operations": {
            icon: "🔄",
            algorithms: {
              "Merge Sorted Lists": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Merges two or more sorted linked lists into a single sorted linked list while maintaining the sorted order of elements.",
                howItWorks: "Use dummy node and pointer to build result. Compare heads of input lists, attach smaller one to result, advance that pointer. Continue until all lists processed.",
                whyUseIt: "Fundamental merge operation in divide-and-conquer algorithms. Essential for merge sort implementation and k-way merge problems. Efficient O(n) solution.",
                useWhen: "Merging sorted data structures, divide and conquer algorithms, k-way merge problems, implementing merge sort for linked lists.",
                keyPoints: "Use dummy node to simplify edge cases. Compare current nodes and advance smaller one. Attach remaining nodes after one list exhausted. For k lists, use min-heap or divide-and-conquer.",
                codeExample: `def combine_sorted_lists(l1, l2):
      dummy = ListNode(0)
      current = dummy
      
      while l1 and l2:
          if l1.val <= l2.val:
              current.next = l1
              l1 = l1.next
          else:
              current.next = l2
              l2 = l2.next
          current = current.next
      
      current.next = l1 or l2
      return dummy.next`
              },
              "Merge k Sorted Lists": {
                complexity: "O(n log k)",
                spaceComplexity: "O(log k)",
                difficulty: 3,
                description: "Merges k sorted linked lists using divide-and-conquer approach or priority queue for optimal efficiency.",
                howItWorks: "Use divide-and-conquer to merge pairs of lists recursively, or use min-heap to always merge the smallest available nodes.",
                whyUseIt: "Optimal solution for k-way merge problem. More efficient than merging sequentially. Demonstrates advanced data structure usage.",
                useWhen: "Large-scale data merging, external sorting, k-way merge scenarios, distributed system data aggregation.",
                keyPoints: "Divide-and-conquer approach is O(n log k). Heap approach needs careful handling of None values. Can use iterative or recursive implementation.",
                codeExample: `import heapq

def mergeKLists(lists):
    heap = []
    dummy = ListNode(0)
    current = dummy
    
    # Initialize heap with first node from each list
    for i, head in enumerate(lists):
        if head:
            heapq.heappush(heap, (head.val, i, head))
    
    while heap:
        val, i, node = heapq.heappop(heap)
        current.next = node
        current = current.next
        
        if node.next:
            heapq.heappush(heap, (node.next.val, i, node.next))
    
    return dummy.next`
              }
            }
          },
          "Complex Operations": {
            icon: "🔧",
            algorithms: {
              "Copy List with Random Pointer": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 3,
                description: "Creates a deep copy of linked list where each node has an additional random pointer that can point to any node in the list.",
                howItWorks: "Three-pass algorithm: 1) Create new nodes attached to originals, 2) Copy random pointers, 3) Separate the two lists.",
                whyUseIt: "Demonstrates advanced pointer manipulation without extra space. Classic problem requiring creative linking approach.",
                useWhen: "Deep copying complex data structures, maintaining arbitrary pointer relationships, advanced linked list problems.",
                keyPoints: "Interweave original and copied nodes. Use original.next to find copied node. Separate lists carefully in final pass.",
                codeExample: `def copyRandomList(head):
      if not head:
          return None
      
      # First pass: create new nodes and attach to originals
      current = head
      while current:
          new_node = Node(current.val)
          new_node.next = current.next
          current.next = new_node
          current = new_node.next
      
      # Second pass: copy random pointers
      current = head
      while current:
          if current.random:
              current.next.random = current.random.next
          current = current.next.next
      
      # Third pass: separate the two lists
      dummy = Node(0)
      current_new = dummy
      current = head
      
      while current:
          current_new.next = current.next
          current.next = current.next.next
          current_new = current_new.next
          current = current.next
      
      return dummy.next`
              },
              "Add Two Numbers": {
                complexity: "O(max(m,n))",
                spaceComplexity: "O(max(m,n))",
                difficulty: 2,
                description: "Adds two numbers represented as linked lists where digits are stored in reverse order, handling carry propagation.",
                howItWorks: "Traverse both lists simultaneously, add corresponding digits plus carry, create new nodes for result, handle different length lists.",
                whyUseIt: "Simulates elementary addition algorithm on linked lists. Good practice for handling multiple pointers and carry logic.",
                useWhen: "Arithmetic on large numbers, digit-by-digit processing, simulation of mathematical operations, handling different length inputs.",
                keyPoints: "Handle carry properly. Different list lengths require careful handling. Create new list for result. Don't forget final carry.",
                codeExample: `def addTwoNumbers(l1, l2):
      dummy = ListNode(0)
      current = dummy
      carry = 0
      
      while l1 or l2 or carry:
          val1 = l1.val if l1 else 0
          val2 = l2.val if l2 else 0
          
          total = val1 + val2 + carry
          carry = total // 10
          digit = total % 10
          
          current.next = ListNode(digit)
          current = current.next
          
          l1 = l1.next if l1 else None
          l2 = l2.next if l2 else None
      
      return dummy.next`
              },
              "Swap Nodes in Pairs": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Swaps every two adjacent nodes in a linked list and returns the head of the modified list.",
                howItWorks: "Use dummy node and careful pointer manipulation to swap pairs. Track previous node to maintain connections.",
                whyUseIt: "Demonstrates systematic pointer swapping. Good practice for maintaining list integrity during transformations.",
                useWhen: "Pair-wise transformations, systematic node swapping, list restructuring problems, interview practice.",
                keyPoints: "Use dummy node for edge cases. Swap requires careful pointer order. Handle odd-length lists properly.",
                codeExample: `def swapPairs(head):
      dummy = ListNode(0)
      dummy.next = head
      prev = dummy
      
      while prev.next and prev.next.next:
          # Nodes to be swapped
          first = prev.next
          second = prev.next.next
          
          # Perform swap
          prev.next = second
          first.next = second.next
          second.next = first
          
          # Move to next pair
          prev = first
      
      return dummy.next`
              },
              "Reverse Nodes in k-Group": {
                complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 3,
                description: "Reverses nodes in groups of k. If the number of nodes is not a multiple of k, the remaining nodes stay as is.",
                howItWorks: "Count k nodes, reverse that group, connect with previous and next groups. Use recursion or iteration with careful pointer management.",
                whyUseIt: "Combines group processing with reversal. Advanced pointer manipulation demonstrating systematic group operations.",
                useWhen: "Group-based transformations, batch processing of linked lists, advanced reversal problems, systematic data reorganization.",
                keyPoints: "Check if k nodes available before reversing. Reverse each group individually. Connect groups properly. Handle remainder nodes.",
                codeExample: `def reverseKGroup(head, k):
      def reverse_group(start, end):
          prev, current = None, start
          while current != end:
              next_temp = current.next
              current.next = prev
              prev = current
              current = next_temp
          return prev
      
      # Check if we have k nodes
      current = head
      for _ in range(k):
          if not current:
              return head
          current = current.next
      
      # Reverse current group
      new_head = reverse_group(head, current)
      
      # Recursively process remaining groups
      head.next = reverseKGroup(current, k)
      
      return new_head`
              }
            }
          },
          "Advanced Linked List Algorithms": {
            icon: "🎯",
            algorithms: {
              "Intersection & Palindrome": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds intersection point where two linked lists merge, or determines if a linked list reads the same forwards and backwards (palindrome).",
                howItWorks: "For intersection: use two pointers that switch lists when reaching end. For palindrome: reverse second half and compare with first half.",
                whyUseIt: "Elegant pointer-based solutions that avoid extra space. Intersection uses length-balancing technique. Palindrome check uses list reversal properties.",
                useWhen: "Finding common nodes, validating palindrome structure, detecting Y-shaped linked list merges, checking data structure symmetry.",
                keyPoints: "For intersection: pointers switch lists to equalize lengths. For palindrome: find middle, reverse second half, compare. Restore original structure after palindrome check.",
                codeExample: `def getIntersectionNode(headA, headB):
      if not headA or not headB:
          return None
      
      a, b = headA, headB
      while a != b:
          a = a.next if a else headB
          b = b.next if b else headA
      
      return a
  
  def isPalindrome(head):
      slow = fast = head
      while fast and fast.next:
          slow = slow.next
          fast = fast.next.next
      
      prev = None
      while slow:
          next_temp = slow.next
          slow.next = prev
          prev = slow
          slow = next_temp
      
      left, right = head, prev
      while right:
          if left.val != right.val:
              return False
          left = left.next
          right = right.next
      
      return True`
              }
            }
          }
        }
      },
      "Advanced Sorting Algorithms": {
        sectionIcon: "🔀",
        patternCount: 11,
        subcategories: {
          "Non-Comparison Sorts": {
            icon: "🏎️",
            algorithms: {
              "Counting Sort": {
                complexity: "O(n + k)",
                spaceComplexity: "O(k)",
                difficulty: 2,
                description: "Non-comparison sorting algorithm that counts occurrences of each element, works efficiently when range of input is small.",
                howItWorks: "Count frequency of each element, calculate cumulative counts, place elements in output array based on counts.",
                whyUseIt: "Linear time when range k is small compared to n. Stable sorting algorithm. No comparisons needed.",
                useWhen: "Small range of integer keys, need stable sort, range k << n, counting frequencies anyway.",
                keyPoints: "Works only with integers or can be mapped to integers. Range k affects space complexity. Stable algorithm.",
                codeExample: `def sort_by_frequency(arr):
      if not arr:
          return arr
      
      # Find the range of input
      max_val = max(arr)
      min_val = min(arr)
      range_val = max_val - min_val + 1
      
      # Initialize count array
      count = [0] * range_val
      output = [0] * len(arr)
      
      # Count frequency of each element
      for num in arr:
          count[num - min_val] += 1
      
      # Calculate cumulative counts
      for i in range(1, range_val):
          count[i] += count[i - 1]
      
      # Build output array
      for i in range(len(arr) - 1, -1, -1):
          output[count[arr[i] - min_val] - 1] = arr[i]
          count[arr[i] - min_val] -= 1
      
      return output`
              },
              "Radix Sort": {
                complexity: "O(d * (n + k))",
                spaceComplexity: "O(n + k)",
                difficulty: 2,
                description: "Non-comparison sorting algorithm that sorts elements digit by digit using counting sort as subroutine.",
                howItWorks: "Sort by least significant digit first, then by next digit, continuing until most significant digit. Use stable sorting for each digit.",
                whyUseIt: "Efficient for integers and strings. Linear time when number of digits d is constant. Good cache performance.",
                useWhen: "Sorting integers, fixed-length strings, when comparison is expensive, large datasets with small key range.",
                keyPoints: "Number of digits d affects performance. Requires stable sorting subroutine. Works with any radix (base).",
                codeExample: `def sort_by_digits(arr):
      if not arr:
          return arr
      
      # Find maximum number to know number of digits
      max_num = max(arr)
      
      # Do counting sort for every digit
      exp = 1
      while max_num // exp > 0:
          sort_by_single_digit(arr, exp)
          exp *= 10
      
      return arr
  
  def sort_by_single_digit(arr, exp):
      n = len(arr)
      output = [0] * n
      count = [0] * 10
      
      # Count occurrences of digits
      for num in arr:
          index = (num // exp) % 10
          count[index] += 1
      
      # Calculate cumulative counts
      for i in range(1, 10):
          count[i] += count[i - 1]
      
      # Build output array
      for i in range(n - 1, -1, -1):
          index = (arr[i] // exp) % 10
          output[count[index] - 1] = arr[i]
          count[index] -= 1
      
      # Copy output array to arr
      for i in range(n):
          arr[i] = output[i]`
              },
              "Bucket Sort": {
                complexity: "O(n + k) average, O(n²) worst",
                spaceComplexity: "O(n + k)",
                difficulty: 2,
                description: "Distributes elements into buckets, sorts individual buckets, then concatenates sorted buckets.",
                howItWorks: "Create k buckets, distribute elements into buckets based on value, sort each bucket individually, concatenate results.",
                whyUseIt: "Average linear time performance. Good when input is uniformly distributed. Parallelizable algorithm.",
                useWhen: "Input uniformly distributed, floating-point numbers, can parallelize sorting, know input distribution.",
                keyPoints: "Performance depends on input distribution. Bucket size affects performance. Can use any sorting algorithm for buckets.",
                codeExample: `def distribute_and_sort(arr):
      if not arr:
          return arr
      
      # Find max and min values
      max_val = max(arr)
      min_val = min(arr)
      
      # Create buckets
      bucket_count = len(arr)
      buckets = [[] for _ in range(bucket_count)]
      
      # Distribute elements into buckets
      for num in arr:
          if max_val == min_val:
              bucket_index = 0
          else:
              bucket_index = int((num - min_val) * (bucket_count - 1) / (max_val - min_val))
          buckets[bucket_index].append(num)
      
      # Sort individual buckets and concatenate
      result = []
      for bucket in buckets:
          bucket.sort()  # Can use any sorting algorithm
          result.extend(bucket)
      
      return result`
              }
            }
          },
          "Advanced Comparison Sorts": {
            icon: "⚡",
            algorithms: {
              "Heap Sort": {
                complexity: "O(n log n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Comparison-based sorting algorithm using binary heap data structure, guarantees O(n log n) performance.",
                howItWorks: "Build max heap from array, repeatedly extract maximum element and place at end, restore heap property.",
                whyUseIt: "Guaranteed O(n log n) time complexity. In-place sorting. Not affected by input distribution. Good worst-case performance.",
                useWhen: "Need guaranteed performance, memory constraints, when quicksort's worst case is problematic, embedded systems.",
                keyPoints: "Not stable. In-place algorithm. Consistent performance regardless of input. Uses heap data structure.",
                codeExample: `def sort_using_tree(arr):
      def maintain_property(arr, n, i):
          largest = i
          left = 2 * i + 1
          right = 2 * i + 2
          
          if left < n and arr[left] > arr[largest]:
              largest = left
          
          if right < n and arr[right] > arr[largest]:
              largest = right
          
          if largest != i:
              arr[i], arr[largest] = arr[largest], arr[i]
              maintain_property(arr, n, largest)
      
      n = len(arr)
      
      # Build max heap
      for i in range(n // 2 - 1, -1, -1):
          maintain_property(arr, n, i)
      
      # Extract elements from heap
      for i in range(n - 1, 0, -1):
          arr[0], arr[i] = arr[i], arr[0]
          maintain_property(arr, i, 0)
      
      return arr`
              },
              "Intro Sort": {
                complexity: "O(n log n)",
                spaceComplexity: "O(log n)",
                difficulty: 3,
                description: "Hybrid sorting algorithm using quicksort, heapsort, and insertion sort. Switches algorithms based on recursion depth and array size.",
                howItWorks: "Start with quicksort, switch to heapsort when recursion depth exceeds 2*log(n), use insertion sort for small arrays.",
                whyUseIt: "Combines best of multiple algorithms. Guarantees O(n log n) worst case. Used in many standard libraries (C++ std::sort).",
                useWhen: "General-purpose sorting, when need guaranteed performance with good average case, standard library implementations.",
                keyPoints: "Hybrid approach combining three algorithms. Adaptive to input characteristics. Optimal for most real-world data.",
                codeExample: `import math
  
  def intro_sort(arr):
      def intro_sort_util(arr, begin, end, depth_limit):
          size = end - begin
          
          if size <= 16:
              insertion_sort_range(arr, begin, end)
          elif depth_limit == 0:
              heap_sort_range(arr, begin, end)
          else:
              pivot = partition(arr, begin, end)
              intro_sort_util(arr, begin, pivot, depth_limit - 1)
              intro_sort_util(arr, pivot + 1, end, depth_limit - 1)
      
      if len(arr) <= 1:
          return arr
      
      depth_limit = 2 * int(math.log2(len(arr)))
      intro_sort_util(arr, 0, len(arr), depth_limit)
      return arr`
              },
              "Tim Sort": {
                complexity: "O(n log n) worst, O(n) best",
                spaceComplexity: "O(n)",
                difficulty: 3,
                description: "Adaptive hybrid sorting algorithm derived from merge sort and insertion sort, optimized for real-world data patterns.",
                howItWorks: "Identifies existing runs in data, extends short runs with insertion sort, merges runs intelligently using sophisticated merge strategy.",
                whyUseIt: "Excellent performance on many real-world datasets. Stable sorting. Adaptive to existing order. Used in Python and Java.",
                useWhen: "Real-world data with existing patterns, need stable sort, partially sorted data, when adaptive performance matters.",
                keyPoints: "Adaptive algorithm. Stable sort. Excellent for real-world data. Complex implementation but great performance.",
                codeExample: `def tim_sort(arr):
      MIN_MERGE = 32
      
      def insertion_sort_range(arr, left, right):
          for i in range(left + 1, right + 1):
              key = arr[i]
              j = i - 1
              while j >= left and arr[j] > key:
                  arr[j + 1] = arr[j]
                  j -= 1
              arr[j + 1] = key
      
      def merge(arr, left, mid, right):
          left_arr = arr[left:mid + 1]
          right_arr = arr[mid + 1:right + 1]
          
          i = j = 0
          k = left
          
          while i < len(left_arr) and j < len(right_arr):
              if left_arr[i] <= right_arr[j]:
                  arr[k] = left_arr[i]
                  i += 1
              else:
                  arr[k] = right_arr[j]
                  j += 1
              k += 1
          
          while i < len(left_arr):
              arr[k] = left_arr[i]
              i += 1
              k += 1
          
          while j < len(right_arr):
              arr[k] = right_arr[j]
              j += 1
              k += 1
      
      n = len(arr)
      
      # Sort individual runs of size MIN_MERGE
      for start in range(0, n, MIN_MERGE):
          end = min(start + MIN_MERGE - 1, n - 1)
          insertion_sort_range(arr, start, end)
      
      # Merge from size MIN_MERGE
      size = MIN_MERGE
      while size < n:
          for start in range(0, n, size * 2):
              mid = start + size - 1
              end = min(start + size * 2 - 1, n - 1)
              
              if mid < end:
                  merge(arr, start, mid, end)
          
          size *= 2
      
      return arr`
              }
            }
          },
          "Specialized Sorts": {
            icon: "🎯",
            algorithms: {
              "Shell Sort": {
                complexity: "O(n log n) to O(n²)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Variation of insertion sort that allows exchange of far apart elements, uses diminishing gap sequence.",
                howItWorks: "Start with large gap, sort elements that are gap positions apart, reduce gap and repeat until gap becomes 1.",
                whyUseIt: "Improvement over insertion sort. In-place algorithm. Simple implementation. Good for medium-sized arrays.",
                useWhen: "Medium-sized arrays, when memory is limited, simple implementation needed, educational purposes.",
                keyPoints: "Gap sequence affects performance. In-place sorting. Not stable. Simple to implement.",
                codeExample: `def gap_insertion_sort(arr):
      n = len(arr)
      gap = n // 2
      
      while gap > 0:
          for i in range(gap, n):
              temp = arr[i]
              j = i
              
              while j >= gap and arr[j - gap] > temp:
                  arr[j] = arr[j - gap]
                  j -= gap
              
              arr[j] = temp
          
          gap //= 2
      
      return arr`
              },
              "Cocktail Shaker Sort": {
                complexity: "O(n²)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Variation of bubble sort that sorts in both directions alternately, also known as bidirectional bubble sort.",
                howItWorks: "Bubble largest element to right, then bubble smallest element to left, repeat with reduced range.",
                whyUseIt: "Slight improvement over bubble sort. Handles turtles (small elements at end) better than bubble sort.",
                useWhen: "Educational purposes, small datasets, when bubble sort behavior needs improvement.",
                keyPoints: "Still O(n²) complexity. In-place sorting. Slight improvement over bubble sort. Bidirectional approach.",
                codeExample: `def bidirectional_bubble(arr):
      n = len(arr)
      start = 0
      end = n - 1
      swapped = True
      
      while swapped:
          swapped = False
          
          # Forward pass
          for i in range(start, end):
              if arr[i] > arr[i + 1]:
                  arr[i], arr[i + 1] = arr[i + 1], arr[i]
                  swapped = True
          
          if not swapped:
              break
          
          end -= 1
          swapped = False
          
          # Backward pass
          for i in range(end - 1, start - 1, -1):
              if arr[i] > arr[i + 1]:
                  arr[i], arr[i + 1] = arr[i + 1], arr[i]
                  swapped = True
          
          start += 1
      
      return arr`
              },
              "Comb Sort": {
                complexity: "O(n²) worst, O(n log n) average",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Improvement over bubble sort using gap sequence, eliminates small values at end of list (turtles) efficiently.",
                howItWorks: "Start with large gap (n/1.3), compare and swap elements gap positions apart, reduce gap by factor 1.3, repeat until gap becomes 1.",
                whyUseIt: "Significant improvement over bubble sort. Simple implementation. In-place sorting. Good average-case performance.",
                useWhen: "Alternative to bubble sort, simple sorting needed, educational purposes, medium-sized arrays.",
                keyPoints: "Shrink factor 1.3 is optimal. In-place algorithm. Not stable. Much better than bubble sort.",
                codeExample: `def comb_sort(arr):
      n = len(arr)
      gap = n
      shrink = 1.3
      sorted_array = False
      
      while not sorted_array:
          gap = int(gap / shrink)
          
          if gap <= 1:
              gap = 1
              sorted_array = True
          
          i = 0
          while i + gap < n:
              if arr[i] > arr[i + gap]:
                  arr[i], arr[i + gap] = arr[i + gap], arr[i]
                  sorted_array = False
              i += 1
      
      return arr`
              },
              "Cycle Sort": {
                complexity: "O(n²)",
                spaceComplexity: "O(1)",
                difficulty: 3,
                description: "In-place sorting algorithm that minimizes the number of writes, useful when write operations are expensive.",
                howItWorks: "For each element, calculate its correct position and place it there, handling cycles of displaced elements.",
                whyUseIt: "Minimizes memory writes. In-place sorting. Useful when write operations are expensive (flash memory, databases).",
                useWhen: "Write operations expensive, flash memory systems, database applications, when minimizing writes is crucial.",
                keyPoints: "Minimizes writes but not swaps. O(n²) comparisons. In-place algorithm. Handles duplicates well.",
                codeExample: `def cycle_sort(arr):
      writes = 0
      
      for cycle_start in range(len(arr) - 1):
          item = arr[cycle_start]
          pos = cycle_start
          
          # Find position where item should go
          for i in range(cycle_start + 1, len(arr)):
              if arr[i] < item:
                  pos += 1
          
          # If item is already in correct position
          if pos == cycle_start:
              continue
          
          # Skip duplicates
          while item == arr[pos]:
              pos += 1
          
          # Put item in correct position
          arr[pos], item = item, arr[pos]
          writes += 1
          
          # Rotate rest of cycle
          while pos != cycle_start:
              pos = cycle_start
              
              for i in range(cycle_start + 1, len(arr)):
                  if arr[i] < item:
                      pos += 1
              
              while item == arr[pos]:
                  pos += 1
              
              arr[pos], item = item, arr[pos]
              writes += 1
      
      return arr`
              },
              "Pancake Sort": {
                complexity: "O(n²)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Sorting algorithm where only operation allowed is reversing elements from beginning to any position (flip operation).",
                howItWorks: "Find maximum element, flip to bring it to front, flip again to put it at end, repeat for remaining elements.",
                whyUseIt: "Interesting theoretical algorithm. Demonstrates problem solving with limited operations. Educational value.",
                useWhen: "Theoretical problems, educational purposes, when only flip operation available, algorithmic puzzles.",
                keyPoints: "Uses only flip operations. At most 2(n-1) flips needed. In-place algorithm. Educational algorithm.",
                codeExample: `def pancake_sort(arr):
      def flip(arr, k):
          start = 0
          while start < k:
              arr[start], arr[k] = arr[k], arr[start]
              start += 1
              k -= 1
      
      def find_max_index(arr, n):
          max_idx = 0
          for i in range(1, n):
              if arr[i] > arr[max_idx]:
                  max_idx = i
          return max_idx
      
      n = len(arr)
      
      for curr_size in range(n, 1, -1):
          max_idx = find_max_index(arr, curr_size)
          
          if max_idx != curr_size - 1:
              # Move maximum to beginning if not already
              if max_idx != 0:
                  flip(arr, max_idx)
              
              # Move maximum to end
              flip(arr, curr_size - 1)
      
      return arr`
              }
            }
          }
        }
      },
      "Trees & Graphs": {
        sectionIcon: "🌳",
        patternCount: 15,
        subcategories: {
          "Tree Traversals (DFS/BFS)": {
            icon: "🔄",
            algorithms: {
              "Binary Tree DFS": {
                complexity: "O(n)",
                spaceComplexity: "O(h)",
                difficulty: 1,
                description: "Performs depth-first traversal of binary trees in three orders: preorder (root-left-right), inorder (left-root-right), postorder (left-right-root).",
                howItWorks: "Recursively visit nodes in specific order. Preorder processes root first, inorder processes root between subtrees, postorder processes root last.",
                whyUseIt: "Different orders serve different purposes. Preorder for copying/serialization, inorder for sorted output in BST, postorder for deletion/cleanup operations.",
                useWhen: "Tree serialization, expression evaluation, tree construction, converting tree to array, validating tree properties.",
                keyPoints: "Inorder gives sorted sequence for BST. Preorder good for tree copying. Postorder ensures children processed before parent. Can implement iteratively using stack.",
                codeExample: `def preorderTraversal(root):
      result = []
      def dfs(node):
          if node:
              result.append(node.val)
              dfs(node.left)
              dfs(node.right)
      dfs(root)
      return result
  
  def inorderTraversal(root):
      result = []
      def dfs(node):
          if node:
              dfs(node.left)
              result.append(node.val)
              dfs(node.right)
      dfs(root)
      return result`
              },
              "Binary Tree BFS (Level Order)": {              complexity: "O(n)",
                spaceComplexity: "O(w)",
                difficulty: 1,
                description: "Traverses binary tree level by level from top to bottom, processing all nodes at each depth before moving to the next level.",
                howItWorks: "Uses queue data structure. Add root to queue, then repeatedly: process all nodes at current level, add their children to queue for next level.",
                whyUseIt: "Guarantees nodes processed by level. Essential for shortest path in unweighted trees, finding tree properties by level, serialization by level.",
                useWhen: "Level order printing, finding tree depth/width, zigzag traversal, finding rightmost node at each level, tree serialization by levels.",
                keyPoints: "Use queue (deque) for FIFO processing. Track level size to process level by level. Can modify for zigzag, right view, or level sums. Time O(n), Space O(w) where w is max width.",
                codeExample: `from collections import deque
  
  def levelOrder(root):
      if not root:
          return []
      
      result = []
      queue = deque([root])
      
      while queue:
          level_size = len(queue)
          level = []
          
          for _ in range(level_size):
              node = queue.popleft()
              level.append(node.val)
              
              if node.left:
                  queue.append(node.left)
              if node.right:
                  queue.append(node.right)
          
          result.append(level)
      return result`
              }
            }
          },
          "Graph Algorithms": {
            icon: "🕸️",
            algorithms: {
              "Graph DFS/BFS": {
                complexity: "O(V+E)",
                spaceComplexity: "O(V)",
                difficulty: 1,
                description: "Traverses graphs using depth-first search (DFS) or breadth-first search (BFS) to explore connected components, detect cycles, and find paths between nodes.",
                howItWorks: "DFS uses recursion/stack to go deep before backtracking. BFS uses queue to explore level by level. Both mark visited nodes to avoid cycles.",
                whyUseIt: "Fundamental graph algorithms. DFS good for cycle detection and topological sort. BFS guarantees shortest path in unweighted graphs.",
                useWhen: "Connected components, cycle detection, path finding, topological sort, maze solving, social network analysis.",
                keyPoints: "DFS: recursive with stack, good for detecting cycles. BFS: iterative with queue, finds shortest path. Always track visited nodes. Time O(V+E), Space O(V).",
                codeExample: `def numIslands(grid):
      if not grid:
          return 0
      
      rows, cols = len(grid), len(grid[0])
      visited = set()
      islands = 0
      
      def dfs(r, c):
          if (r < 0 or r >= rows or c < 0 or c >= cols or
              (r, c) in visited or grid[r][c] == '0'):
              return
          
          visited.add((r, c))
          directions = [(0, 1), (1, 0), (0, -1), (-1, 0)]
          for dr, dc in directions:
              dfs(r + dr, c + dc)
      
      for r in range(rows):
          for c in range(cols):
              if grid[r][c] == '1' and (r, c) not in visited:
                  dfs(r, c)
                  islands += 1
      
      return islands`
              },
              "Flood Fill & Clone Graph": {              complexity: "O(n)",
                spaceComplexity: "O(V)",
                difficulty: 2,
                description: "Applies DFS/BFS to modify connected regions or create deep copies of graph structures, typically used for flood fill and graph cloning operations.",
                howItWorks: "For flood fill: start from seed point, recursively change color of connected same-colored cells. For graph cloning: traverse original graph while creating new nodes and edges.",
                whyUseIt: "Essential for image processing, game development, and graph manipulation. Efficiently processes connected regions in one pass.",
                useWhen: "Flood fill algorithms, graph cloning, image processing, region connectivity, paint bucket tools, maze solving.",
                keyPoints: "Check bounds and avoid infinite recursion. For flood fill, check if already target color. For graph cloning, use hashmap to track cloned nodes. Handle cycles properly.",
                codeExample: `def floodFill(image, sr, sc, newColor):
      if not image or image[sr][sc] == newColor:
          return image
      
      original_color = image[sr][sc]
      rows, cols = len(image), len(image[0])
      
      def dfs(r, c):
          if (r < 0 or r >= rows or c < 0 or c >= cols or 
              image[r][c] != original_color):
              return
          
          image[r][c] = newColor
          
          dfs(r + 1, c)
          dfs(r - 1, c)
          dfs(r, c + 1)
          dfs(r, c - 1)
      
      dfs(sr, sc)
      return image`
              }
            }
          },
          "Binary Search Tree Operations": {
            icon: "🔍",
            algorithms: {
              "BST Validation & Operations": {              complexity: "O(log n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Validates binary search tree properties and performs efficient search, insertion, deletion operations while maintaining the BST invariant.",
                howItWorks: "BST property: left subtree < root < right subtree. Use bounds to validate. For operations, compare with root and recurse left/right accordingly.",
                whyUseIt: "BST provides O(log n) average time for search/insert/delete operations. Inorder traversal gives sorted sequence. Essential for efficient data organization.",
                useWhen: "BST validation, searching for values, finding closest value, LCA in BST, range queries, sorted data access.",
                keyPoints: "Use bounds (min, max) for validation. Left subtree values < root < right subtree values. Inorder traversal gives sorted output. Handle edge cases like empty tree.",
                codeExample: `def isValidBST(root):
      def validate(node, min_val, max_val):
          if not node:
              return True
          
          if node.val <= min_val or node.val >= max_val:
              return False
          
          return (validate(node.left, min_val, node.val) and
                  validate(node.right, node.val, max_val))
      
      return validate(root, float('-inf'), float('inf'))
  
  def searchBST(root, val):
      while root:
          if val == root.val:
              return root
          elif val < root.val:
              root = root.left
          else:
              root = root.right
      return None`
              }
            }
          },
          "Tree Properties & Construction": {
            icon: "🏗️",
            algorithms: {
              "Lowest Common Ancestor": {              complexity: "O(log n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds the lowest common ancestor of two nodes in a binary tree using recursive approach or path-based methods.",
                howItWorks: "If both nodes are on different sides of root, root is LCA. Otherwise, LCA is in the subtree containing both nodes. Use recursive calls to traverse.",
                whyUseIt: "Fundamental tree algorithm with many applications. Tests understanding of tree properties and recursive thinking. Essential for tree navigation problems.",
                useWhen: "Finding common ancestors, tree navigation, version control systems, phylogenetic trees, hierarchical data structures.",
                keyPoints: "Base case: if root is null or equals either node, return root. If nodes on different sides, root is LCA. Otherwise, recurse on appropriate subtree.",
                codeExample: `def lowestCommonAncestor(root, p, q):
      if not root or root == p or root == q:
          return root
      
      left = lowestCommonAncestor(root.left, p, q)
      right = lowestCommonAncestor(root.right, p, q)
      
      if left and right:
          return root
      
      return left or right`
              },
              "Serialize and Deserialize Tree": {              complexity: "O(n)",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Converts binary tree to string representation and reconstructs tree from string using preorder traversal with null markers.",
                howItWorks: "Serialize: preorder traversal with null markers. Deserialize: use queue/iterator to rebuild tree following same preorder pattern.",
                whyUseIt: "Essential for tree persistence, network transmission, and storage. Tests deep understanding of tree traversal and reconstruction.",
                useWhen: "Tree persistence, saving/loading trees, network transmission, deep copying trees, tree storage systems.",
                keyPoints: "Use preorder for serialization. Include null markers in string. Use queue for deserialization. Handle null nodes carefully during reconstruction.",
                codeExample: `def serialize(root):
      def preorder(node):
          if not node:
              return "null,"
          return str(node.val) + "," + preorder(node.left) + preorder(node.right)
      
      return preorder(root)
  
  def deserialize(data):
      def build():
          val = next(vals)
          if val == "null":
              return None
          node = TreeNode(int(val))
          node.left = build()
          node.right = build()
          return node
      
      vals = iter(data.split(","))
      return build()`
              }
            }
          },
          "Union-Find & Advanced Algorithms": {
            icon: "🔗",
            algorithms: {
              "Union-Find (Disjoint Set)": {
                complexity: "O(α(n))",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Efficiently tracks connected components in a graph with near-constant time union and find operations using path compression and union by rank.",
                howItWorks: "Each element has a parent pointer. Find follows pointers to root with path compression. Union connects two sets by making one root point to another.",
                whyUseIt: "Provides amortized O(α(n)) time complexity where α is inverse Ackermann function (practically constant). Perfect for dynamic connectivity queries.",
                useWhen: "Connected components, cycle detection in undirected graphs, Kruskal's MST algorithm, network connectivity, percolation problems.",
                keyPoints: "Path compression flattens tree during find. Union by rank keeps trees balanced. Almost constant time operations. Great for dynamic connectivity problems.",
                codeExample: `class UnionFind:
      def __init__(self, n):
          self.parent = list(range(n))
          self.rank = [0] * n
          self.components = n
      
      def find(self, x):
          if self.parent[x] != x:
              self.parent[x] = self.find(self.parent[x])
          return self.parent[x]
      
      def union(self, x, y):
          px, py = self.find(x), self.find(y)
          if px == py:
              return False
          
          if self.rank[px] < self.rank[py]:
              px, py = py, px
          
          self.parent[py] = px
          if self.rank[px] == self.rank[py]:
              self.rank[px] += 1
          
          self.components -= 1
          return True`
              },
              "Topological Sort": {
                complexity: "O(V+E)",
                spaceComplexity: "O(V)",
                difficulty: 2,
                description: "Orders vertices in a directed acyclic graph (DAG) such that for every directed edge u→v, vertex u comes before v in the ordering.",
                howItWorks: "Two approaches: Kahn's algorithm (BFS with indegree) or DFS with post-order traversal. Both detect cycles and produce valid ordering if DAG exists.",
                whyUseIt: "Essential for scheduling problems with dependencies. Detects circular dependencies. Provides valid execution order for dependent tasks.",
                useWhen: "Course scheduling, build dependencies, task ordering, prerequisite resolution, compilation order, project planning.",
                keyPoints: "Only works on DAGs (no cycles). Kahn's: remove nodes with 0 indegree. DFS: add to result after visiting all dependencies. Multiple valid orderings possible.",
                codeExample: `from collections import deque, defaultdict
  
  def topologicalSort(numCourses, prerequisites):
      graph = defaultdict(list)
      indegree = [0] * numCourses
      
      for course, prereq in prerequisites:
          graph[prereq].append(course)
          indegree[course] += 1
      
      queue = deque([i for i in range(numCourses) if indegree[i] == 0])
      result = []
      
      while queue:
          node = queue.popleft()
          result.append(node)
          
          for neighbor in graph[node]:
              indegree[neighbor] -= 1
              if indegree[neighbor] == 0:
                  queue.append(neighbor)
      
      return result if len(result) == numCourses else []`
              },
              "Course Schedule II": {              complexity: "O(V + E)",
                spaceComplexity: "O(V+E)",
                difficulty: 2,
                description: "Returns a valid ordering of courses that satisfies all prerequisites using topological sort, or empty array if impossible due to cycles.",
                howItWorks: "Build adjacency list from prerequisites. Use Kahn's algorithm with in-degree counting. Process courses with no prerequisites first, reducing in-degree of dependent courses.",
                whyUseIt: "Practical application of topological sort with cycle detection. Demonstrates dependency resolution in real-world scenarios. Essential for course scheduling systems.",
                useWhen: "Course scheduling, prerequisite checking, dependency resolution, task ordering with constraints, academic planning systems.",
                keyPoints: "Build graph from prerequisites. Use in-degree array. Process 0 in-degree nodes first. If result length < numCourses, cycle exists. Return empty array for cycles.",
                codeExample: `def findOrder(numCourses, prerequisites):
      graph = [[] for _ in range(numCourses)]
      in_degree = [0] * numCourses
      
      # Build graph and calculate in-degrees
      for course, prereq in prerequisites:
          graph[prereq].append(course)
          in_degree[course] += 1
      
      # Find courses with no prerequisites
      queue = [i for i in range(numCourses) if in_degree[i] == 0]
      result = []
      
      while queue:
          course = queue.pop(0)
          result.append(course)
          
          for dependent in graph[course]:
              in_degree[dependent] -= 1
              if in_degree[dependent] == 0:
                  queue.append(dependent)
      
      return result if len(result) == numCourses else []`
              }
            }
          },
          "Shortest Path Algorithms": {
            icon: "🗺️",
            algorithms: {
              "Dijkstra's Algorithm": {
                complexity: "O((V + E) log V)",
                spaceComplexity: "O(V)",
                difficulty: 2,
                description: "Finds the shortest path from a source vertex to all other vertices in a weighted graph with non-negative edge weights using a greedy approach.",
                howItWorks: "Use priority queue (min-heap) to always process the vertex with minimum distance. Update distances to neighbors if a shorter path is found. Guarantees optimal solution for non-negative weights.",
                whyUseIt: "Optimal algorithm for single-source shortest path with non-negative weights. Foundation for many routing algorithms and network analysis. Essential for weighted graph problems.",
                useWhen: "GPS navigation, network routing, shortest path in weighted graphs, finding minimum cost paths, social network analysis, game pathfinding.",
                keyPoints: "Requires non-negative edge weights. Use min-heap for efficiency. Time complexity depends on priority queue implementation. Cannot handle negative weights (use Bellman-Ford instead).",
                codeExample: `import heapq
  
  def dijkstra(graph, start):
      distances = {node: float('inf') for node in graph}
      distances[start] = 0
      pq = [(0, start)]
      visited = set()
      
      while pq:
          current_dist, current = heapq.heappop(pq)
          
          if current in visited:
              continue
          visited.add(current)
          
          for neighbor, weight in graph[current].items():
              distance = current_dist + weight
              
              if distance < distances[neighbor]:
                  distances[neighbor] = distance
                  heapq.heappush(pq, (distance, neighbor))
      
      return distances
  
  def networkDelayTime(times, n, k):
      graph = {i: {} for i in range(1, n + 1)}
      for u, v, w in times:
          graph[u][v] = w
      
      distances = dijkstra(graph, k)
      max_dist = max(distances.values())
      
      return max_dist if max_dist != float('inf') else -1`
              },
              "Bellman-Ford Algorithm": {              complexity: "O(VE)",
                spaceComplexity: "O(V)",
                difficulty: 3,
                description: "Finds shortest paths from a source vertex to all other vertices in a weighted graph, can handle negative edge weights and detect negative cycles.",
                howItWorks: "Relax all edges V-1 times. For each relaxation round, update distances if a shorter path is found. Check for negative cycles by doing one more iteration.",
                whyUseIt: "Only algorithm that can handle negative edge weights. Can detect negative cycles. More versatile than Dijkstra's but slower time complexity.",
                useWhen: "Graphs with negative edge weights, detecting negative cycles, currency arbitrage, network analysis with penalties, constraint satisfaction.",
                keyPoints: "Can handle negative weights. V-1 iterations guarantee shortest path if no negative cycles. One extra iteration detects negative cycles. Slower than Dijkstra's but more versatile.",
                codeExample: `def bellman_ford(graph, start):
      # Initialize distances
      distances = {node: float('inf') for node in graph}
      distances[start] = 0
      
      # Relax edges V-1 times
      for _ in range(len(graph) - 1):
          for node in graph:
              for neighbor, weight in graph[node].items():
                  if distances[node] + weight < distances[neighbor]:
                      distances[neighbor] = distances[node] + weight
      
      # Check for negative cycles
      for node in graph:
          for neighbor, weight in graph[node].items():
              if distances[node] + weight < distances[neighbor]:
                  return None  # Negative cycle detected
      
      return distances`
              },
              "Floyd-Warshall Algorithm": {              complexity: "O(V³)",
                spaceComplexity: "O(V²)",
                difficulty: 3,
                description: "Finds shortest paths between all pairs of vertices in a weighted graph using dynamic programming approach.",
                howItWorks: "Use 3D DP where dp[k][i][j] = shortest path from i to j using vertices 0 to k as intermediate nodes. Can be optimized to 2D array.",
                whyUseIt: "Solves all-pairs shortest path problem in one algorithm. Simple implementation. Can detect negative cycles. Good for dense graphs.",
                useWhen: "All-pairs shortest path, dense graphs, finding graph diameter, detecting negative cycles, distance matrices, network analysis.",
                keyPoints: "O(V³) time makes it suitable only for small graphs. Can detect negative cycles. Simple implementation with 3 nested loops. Space can be optimized to O(V²).",
                codeExample: `def floyd_warshall(graph):
      n = len(graph)
      # Initialize distance matrix
      dist = [[float('inf')] * n for _ in range(n)]
      
      # Set distances from adjacency matrix
      for i in range(n):
          for j in range(n):
              if i == j:
                  dist[i][j] = 0
              elif j in graph[i]:
                  dist[i][j] = graph[i][j]
      
      # Floyd-Warshall algorithm
      for k in range(n):
          for i in range(n):
              for j in range(n):
                  dist[i][j] = min(dist[i][j], dist[i][k] + dist[k][j])
      
      return dist`
              }
            }
          },
          "Minimum Spanning Tree": {
            icon: "🌲",
            algorithms: {
              "Kruskal's Algorithm": {              complexity: "O(E log E)",
                spaceComplexity: "O(1)",
                difficulty: 3,
                description: "Finds minimum spanning tree by sorting edges and adding them if they don't create a cycle, using Union-Find for cycle detection.",
                howItWorks: "Sort all edges by weight. Use Union-Find to track connected components. Add edges that connect different components until MST is formed.",
                whyUseIt: "Efficient for sparse graphs. Easy to implement with Union-Find. Guaranteed to find optimal MST. Good for edge-focused algorithms.",
                useWhen: "Network design, clustering algorithms, image segmentation, approximation algorithms, sparse graphs, road network planning.",
                keyPoints: "Sort edges first. Use Union-Find for cycle detection. Stop when V-1 edges added. Time complexity dominated by sorting. Works well for sparse graphs.",
                codeExample: `class UnionFind:
      def __init__(self, n):
          self.parent = list(range(n))
          self.rank = [0] * n
      
      def find(self, x):
          if self.parent[x] != x:
              self.parent[x] = self.find(self.parent[x])
          return self.parent[x]
      
      def union(self, x, y):
          px, py = self.find(x), self.find(y)
          if px == py:
              return False
          if self.rank[px] < self.rank[py]:
              px, py = py, px
          self.parent[py] = px
          if self.rank[px] == self.rank[py]:
              self.rank[px] += 1
          return True
  
  def kruskal(n, edges):
      edges.sort(key=lambda x: x[2])  # Sort by weight
      uf = UnionFind(n)
      mst = []
      total_weight = 0
      
      for u, v, weight in edges:
          if uf.union(u, v):
              mst.append((u, v, weight))
              total_weight += weight
              if len(mst) == n - 1:
                  break
      
      return mst, total_weight`
              },
              "Prim's Algorithm": {              complexity: "O(E log V)",
                spaceComplexity: "O(V)",
                difficulty: 3,
                description: "Finds minimum spanning tree by growing tree from a starting vertex, always adding the minimum weight edge that connects tree to non-tree vertex.",
                howItWorks: "Start with arbitrary vertex. Use priority queue to track minimum edge weights to non-tree vertices. Add minimum edge and update adjacent edges.",
                whyUseIt: "Better for dense graphs. Vertex-focused approach. Can start from any vertex. Good when you need to track tree growth step by step.",
                useWhen: "Dense graphs, vertex-focused problems, real-time MST construction, network expansion, maze generation, circuit design.",
                keyPoints: "Use priority queue for minimum edge selection. Track visited vertices. Update adjacent edge weights. Time complexity depends on priority queue implementation.",
                codeExample: `import heapq
  
  def prim(graph, start=0):
      n = len(graph)
      mst = []
      visited = [False] * n
      min_heap = [(0, start, -1)]  # (weight, vertex, parent)
      total_weight = 0
      
      while min_heap:
          weight, vertex, parent = heapq.heappop(min_heap)
          
          if visited[vertex]:
              continue
          
          visited[vertex] = True
          if parent != -1:
              mst.append((parent, vertex, weight))
              total_weight += weight
          
          for neighbor, edge_weight in graph[vertex]:
              if not visited[neighbor]:
                  heapq.heappush(min_heap, (edge_weight, neighbor, vertex))
      
      return mst, total_weight`
              }
            }
          }
        }
      },
      "Dynamic Programming": {
        sectionIcon: "🧠",
        patternCount: 9,
        subcategories: {
          "1D Dynamic Programming": {
            icon: "📈",
            algorithms: {
              "Fibonacci Style DP": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Solves optimization problems where each state depends only on the previous 1-2 states, following the Fibonacci sequence pattern.",
                howItWorks: "Define base cases, then build solution bottom-up using recurrence relation. Each dp[i] computed from dp[i-1] and/or dp[i-2].",
                whyUseIt: "Transforms exponential recursive solutions to linear time. Space can often be optimized to O(1) since only previous states needed.",
                useWhen: "Climbing stairs, house robber, fibonacci computation, decode ways, counting problems with adjacent constraints.",
                keyPoints: "Current state depends on 1-2 previous states. Can optimize space from O(n) to O(1). Pattern: dp[i] = f(dp[i-1], dp[i-2]). Handle base cases carefully.",
                codeExample: `def climbStairs(n):
      if n <= 2:
          return n
      
      prev2, prev1 = 1, 2
      for i in range(3, n + 1):
          current = prev1 + prev2
          prev2, prev1 = prev1, current
      
      return prev1
  
  def rob(nums):
      if not nums:
          return 0
      if len(nums) == 1:
          return nums[0]
      
      prev2, prev1 = 0, nums[0]
      for i in range(1, len(nums)):
          current = max(prev1, prev2 + nums[i])
          prev2, prev1 = prev1, current
      
      return prev1`
              },
              "Longest Increasing Subsequence": {              complexity: "O(n log n)",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Finds the longest subsequence of elements where each element is strictly greater than the previous one in the subsequence.",
                howItWorks: "DP approach: dp[i] = length of LIS ending at i. Binary search approach: maintain array of smallest tail elements for each length.",
                whyUseIt: "Classic DP problem with optimization opportunities. Binary search version achieves O(n log n) vs O(n²) DP. Foundation for many sequence problems.",
                useWhen: "LIS problems, longest chain problems, envelope/box stacking, patience sorting, finding maximum increasing sequences.",
                keyPoints: "DP: O(n²) time, easy to understand. Binary search: O(n log n), maintains smallest tails. Both find length; reconstruction needs additional tracking.",
                codeExample: `def lengthOfLIS(nums):
      if not nums:
          return 0
      
      import bisect
      tails = []
      
      for num in nums:
          pos = bisect.bisect_left(tails, num)
          if pos == len(tails):
              tails.append(num)
          else:
              tails[pos] = num
      
      return len(tails)`
              }
            }
          },
          "2D Dynamic Programming": {
            icon: "🎯",
            algorithms: {
              "Grid Path Problems": {              complexity: "O(m×n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Solves path-finding problems in 2D grids where you can only move right or down, often with additional constraints like obstacles or costs.",
                howItWorks: "Build 2D DP table where dp[i][j] represents solution for position (i,j). Current cell depends on cells above and to the left.",
                whyUseIt: "Transforms complex path enumeration into systematic bottom-up calculation. Handles constraints naturally through DP transitions.",
                useWhen: "Unique paths counting, minimum path sum, maximum path sum, grid traversal with obstacles, dungeon game scenarios.",
                keyPoints: "dp[i][j] = dp[i-1][j] + dp[i][j-1] for path counting. Handle obstacles by setting dp[i][j] = 0. Can optimize space to O(n) using 1D array.",
                codeExample: `def uniquePaths(m, n):
      dp = [[1] * n for _ in range(m)]
      
      for i in range(1, m):
          for j in range(1, n):
              dp[i][j] = dp[i-1][j] + dp[i][j-1]
      
      return dp[m-1][n-1]
  
  def minPathSum(grid):
      if not grid:
          return 0
      
      m, n = len(grid), len(grid[0])
      dp = [[0] * n for _ in range(m)]
      
      dp[0][0] = grid[0][0]
      
      for j in range(1, n):
          dp[0][j] = dp[0][j-1] + grid[0][j]
      
      for i in range(1, m):
          dp[i][0] = dp[i-1][0] + grid[i][0]
      
      for i in range(1, m):
          for j in range(1, n):
              dp[i][j] = min(dp[i-1][j], dp[i][j-1]) + grid[i][j]
      
      return dp[m-1][n-1]`
              }
            }
          },
          "Knapsack Problems": {
            icon: "🎒",
            algorithms: {
              "0/1 Knapsack & Variations": {              complexity: "O(n×W)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Solves optimization problems where you select items to maximize value while staying within weight/capacity constraints, with each item used at most once.",
                howItWorks: "2D DP table where dp[i][w] = max value using first i items with weight limit w. For each item, choose max of including or excluding it.",
                whyUseIt: "Classic optimization pattern applicable to many decision problems. Can be space-optimized from O(nW) to O(W). Foundation for subset and partition problems.",
                useWhen: "Subset sum problems, partition equal subset, target sum, capacity optimization, resource allocation with constraints.",
                keyPoints: "dp[i][w] = max(dp[i-1][w], dp[i-1][w-weight] + value). Each item used once. Can optimize space by iterating weights backwards.",
                codeExample: `def canPartition(nums):
      total = sum(nums)
      if total % 2:
          return False
      
      target = total // 2
      dp = [False] * (target + 1)
      dp[0] = True
      
      for num in nums:
          for j in range(target, num - 1, -1):
              dp[j] = dp[j] or dp[j - num]
      
      return dp[target]`
              },
              "Unbounded Knapsack": {              complexity: "O(n×W)",
                spaceComplexity: "O(n*W)",
                difficulty: 2,
                description: "Solves optimization problems where items can be used unlimited times, finding the best combination to meet a target or maximize value.",
                howItWorks: "Similar to 0/1 knapsack but items can be reused. For each capacity, try including each item type multiple times until capacity exceeded.",
                whyUseIt: "Perfect for problems with unlimited resources. Simpler than 0/1 knapsack since no restriction on item usage. Can iterate forwards through weights.",
                useWhen: "Coin change problems, combination sum with repetition, unlimited resource allocation, making amounts with unlimited items.",
                keyPoints: "Iterate weights forward since items can be reused. dp[amount] = min(dp[amount], dp[amount-coin] + 1) for coin change. Simpler than 0/1 knapsack.",
                codeExample: `def coinChange(coins, amount):
      dp = [float('inf')] * (amount + 1)
      dp[0] = 0
      
      for coin in coins:
          for i in range(coin, amount + 1):
              dp[i] = min(dp[i], dp[i - coin] + 1)
      
      return dp[amount] if dp[amount] != float('inf') else -1`
              }
            }
          },
          "String Dynamic Programming": {
            icon: "📝",
            algorithms: {
              "Longest Common Subsequence": {              complexity: "O(m×n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Finds the longest subsequence that appears in both strings in the same relative order, but not necessarily contiguous.",
                howItWorks: "2D DP table where dp[i][j] = LCS length of first i chars of string1 and first j chars of string2. If chars match, add 1 to diagonal; else take max of adjacent cells.",
                whyUseIt: "Foundation for many string comparison algorithms. Used in diff tools, DNA sequence analysis, and text similarity measures. Classic 2D DP example.",
                useWhen: "Finding longest common subsequence, text similarity analysis, diff algorithms, DNA sequence alignment, version control systems.",
                keyPoints: "If chars match: dp[i][j] = dp[i-1][j-1] + 1. If not: dp[i][j] = max(dp[i-1][j], dp[i][j-1]). Can optimize space to O(min(m,n)).",
                codeExample: `def longestCommonSubsequence(text1, text2):
      m, n = len(text1), len(text2)
      dp = [[0] * (n + 1) for _ in range(m + 1)]
      
      for i in range(1, m + 1):
          for j in range(1, n + 1):
              if text1[i-1] == text2[j-1]:
                  dp[i][j] = dp[i-1][j-1] + 1
              else:
                  dp[i][j] = max(dp[i-1][j], dp[i][j-1])
      
      return dp[m][n]`
              },
              "Palindrome DP": {              complexity: "O(n²)",
                spaceComplexity: "O(n²)",
                difficulty: 2,
                description: "Solves palindrome-related problems using dynamic programming to find longest palindromic subsequences, minimum cuts, or optimal palindrome partitions.",
                howItWorks: "2D DP where dp[i][j] represents solution for substring from i to j. For palindromes: if s[i] == s[j], extend inner solution; else take best of excluding either end.",
                whyUseIt: "Efficiently handles overlapping subproblems in palindrome analysis. Avoids exponential brute force by memoizing results. Foundation for many string optimization problems.",
                useWhen: "Longest palindromic subsequence, minimum palindrome insertions, palindrome partitioning, counting palindromic substrings, palindrome optimization.",
                keyPoints: "For LPS: if s[i]==s[j] then dp[i][j] = 2 + dp[i+1][j-1], else max(dp[i+1][j], dp[i][j-1]). Build from smaller lengths to larger.",
                codeExample: `def longestPalindromeSubseq(s):
      n = len(s)
      dp = [[0] * n for _ in range(n)]
      
      for i in range(n):
          dp[i][i] = 1
      
      for length in range(2, n + 1):
          for i in range(n - length + 1):
              j = i + length - 1
              
              if s[i] == s[j]:
                  dp[i][j] = dp[i+1][j-1] + 2
              else:
                  dp[i][j] = max(dp[i+1][j], dp[i][j-1])
      
      return dp[0][n-1]`
              },
              "Advanced DP (Word Break, Pattern Matching)": {              complexity: "O(n²)",
                spaceComplexity: "O(n*m)",
                difficulty: 3,
                description: "Solves complex dynamic programming problems involving word segmentation, pattern matching with wildcards/regex, and interval optimization with non-obvious optimal substructure.",
                howItWorks: "Word break uses prefix DP. Regex matching handles '.' and '*' with careful state transitions. Burst balloons uses interval DP thinking about last operation.",
                whyUseIt: "Handles problems where optimal substructure isn't immediately obvious. Requires careful state definition and transition design. Essential for advanced DP mastery.",
                useWhen: "Word break problems, regular expression matching, wildcard pattern matching, burst balloons, interval optimization, complex state DP.",
                keyPoints: "Word break: check all possible prefixes. Regex: handle '.' (any char) and '*' (zero or more). Burst balloons: think about last balloon to burst.",
                codeExample: `def wordBreak(s, wordDict):
      word_set = set(wordDict)
      dp = [False] * (len(s) + 1)
      dp[0] = True
      
      for i in range(1, len(s) + 1):
          for j in range(i):
              if dp[j] and s[j:i] in word_set:
                  dp[i] = True
                  break
      
      return dp[len(s)]`
              },
              "Edit Distance": {              complexity: "O(m×n)",
                spaceComplexity: "O(m*n)",
                difficulty: 2,
                description: "Finds minimum number of operations (insert, delete, replace) to transform one string into another using dynamic programming.",
                howItWorks: "2D DP where dp[i][j] = min operations to transform first i chars of string1 to first j chars of string2. Choose min of insert, delete, replace operations.",
                whyUseIt: "Classic DP problem demonstrating optimal substructure. Used in spell checkers, DNA analysis, and text similarity. Foundation for understanding string DP.",
                useWhen: "String transformation, spell checking, DNA sequence alignment, text similarity measurement, autocorrect systems.",
                keyPoints: "If characters match, take diagonal value. Otherwise, take 1 + min(left, top, diagonal). Initialize first row and column properly.",
                codeExample: `def minDistance(word1, word2):
      m, n = len(word1), len(word2)
      dp = [[0] * (n + 1) for _ in range(m + 1)]
      
      # Initialize base cases
      for i in range(m + 1):
          dp[i][0] = i
      for j in range(n + 1):
          dp[0][j] = j
      
      for i in range(1, m + 1):
          for j in range(1, n + 1):
              if word1[i-1] == word2[j-1]:
                  dp[i][j] = dp[i-1][j-1]
              else:
                  dp[i][j] = 1 + min(
                      dp[i-1][j],    # delete
                      dp[i][j-1],    # insert  
                      dp[i-1][j-1]   # replace
                  )
      
      return dp[m][n]`
              }
            }
          }
        }
      },
      "Heaps & Priority Queues": {
        sectionIcon: "⛰️",
        patternCount: 3,
        subcategories: {
          "Top K Elements": {
            icon: "🔝",
            algorithms: {
              "K Largest/Smallest Elements": {              complexity: "O(n log k)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Uses heap data structures to efficiently find the K largest or smallest elements from a dataset without fully sorting the data.",
                howItWorks: "For K largest: use min-heap of size K, maintain smallest among K largest. For K smallest: use max-heap of size K, maintain largest among K smallest.",
                whyUseIt: "More efficient than sorting entire array O(n log n). Heap approach is O(n log k) where k is typically much smaller than n. Space efficient O(k).",
                useWhen: "Kth largest element, top K frequent elements, merge K sorted lists, finding closest points, top performers in rankings.",
                keyPoints: "Use min-heap for K largest (root is Kth largest). Use max-heap for K smallest. Maintain heap size = K. Python heapq is min-heap, use negative values for max-heap.",
                codeExample: `import heapq
  
  def findKthLargest(nums, k):
      heap = []
      for num in nums:
          heapq.heappush(heap, num)
          if len(heap) > k:
              heapq.heappop(heap)
      return heap[0]
  
  def topKFrequent(nums, k):
      from collections import Counter
      counter = Counter(nums)
      heap = []
      
      for num, freq in counter.items():
          heapq.heappush(heap, (freq, num))
          if len(heap) > k:
              heapq.heappop(heap)
      
      return [item[1] for item in heap]`
              },
              "Median of Data Stream": {              complexity: "O(log n)",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Maintains the median of a stream of numbers efficiently using two heaps to balance the dataset and provide O(log n) insertion and O(1) median access.",
                howItWorks: "Use max-heap for smaller half and min-heap for larger half. Keep heaps balanced in size. Median is root of larger heap or average of both roots.",
                whyUseIt: "Provides O(log n) insertion and O(1) median finding vs O(n log n) sorting approach. Essential for real-time statistics and streaming data processing.",
                useWhen: "Real-time median calculation, streaming data analysis, sliding window median, online statistics, data stream processing.",
                keyPoints: "Balance heap sizes (differ by at most 1). Max-heap stores smaller half, min-heap stores larger half. Python heapq is min-heap, use negatives for max-heap.",
                codeExample: `import heapq
  
  class MedianFinder:
      def __init__(self):
          self.small = []  # max heap (negative values)
          self.large = []  # min heap
      
      def addNum(self, num):
          heapq.heappush(self.small, -num)
          
          if self.small and self.large and (-self.small[0] > self.large[0]):
              val = -heapq.heappop(self.small)
              heapq.heappush(self.large, val)
          
          if len(self.small) > len(self.large) + 1:
              val = -heapq.heappop(self.small)
              heapq.heappush(self.large, val)
          
          if len(self.large) > len(self.small) + 1:
              val = heapq.heappop(self.large)
              heapq.heappush(self.small, -val)
      
      def findMedian(self):
          if len(self.small) > len(self.large):
              return -self.small[0]
          elif len(self.large) > len(self.small):
              return self.large[0]
          else:
              return (-self.small[0] + self.large[0]) / 2`
              },
              "Sliding Window Maximum": {              complexity: "O(n)",
                spaceComplexity: "O(k)",
                difficulty: 2,
                description: "Finds the maximum element in each sliding window of size k as the window moves across an array, efficiently handling window updates.",
                howItWorks: "Use monotonic deque to maintain potential maximums in decreasing order. Remove elements outside window and smaller elements that can't be maximum.",
                whyUseIt: "Achieves O(n) time complexity vs naive O(nk) approach. Deque maintains candidates efficiently by removing impossible maximums early.",
                useWhen: "Sliding window maximum problems, largest rectangle in histogram, monotonic stack/deque problems, range maximum queries.",
                keyPoints: "Monotonic deque keeps decreasing order. Remove out-of-window elements from front. Remove smaller elements from back. Front always contains maximum.",
                codeExample: `from collections import deque
  
  def maxSlidingWindow(nums, k):
      dq = deque()
      result = []
      
      for i in range(len(nums)):
          while dq and dq[0] <= i - k:
              dq.popleft()
          
          while dq and nums[dq[-1]] < nums[i]:
              dq.pop()
          
          dq.append(i)
          
          if i >= k - 1:
              result.append(nums[dq[0]])
      
      return result`
              }
            }
          }
        }
      },
      "Backtracking": {
        sectionIcon: "🔙",
        patternCount: 4,
        subcategories: {
          "Generate Combinations/Permutations": {
            icon: "🌿",
            algorithms: {
              "Combinations & Subsets": {
                complexity: "O(2^n)",
                spaceComplexity: "O(n)",
                difficulty: 1,
                description: "Generates all possible combinations and subsets by systematically exploring choices and backtracking when constraints are violated or goals reached.",
                howItWorks: "Recursive function that makes a choice, recurses on remaining elements, then undoes the choice (backtrack). Build solution incrementally.",
                whyUseIt: "Systematic exploration of all possibilities without missing any. Backtracking prevents unnecessary computation by pruning invalid paths early.",
                useWhen: "Generating all subsets, combinations with constraints, combination sum problems, generating parentheses, phone number combinations.",
                keyPoints: "Make choice → recurse → backtrack (undo choice). Use start index to avoid duplicates. Add current path to result before recursing for subsets.",
                codeExample: `def subsets(nums):
      result = []
      
      def backtrack(start, path):
          result.append(path[:])
          
          for i in range(start, len(nums)):
              path.append(nums[i])
              backtrack(i + 1, path)
              path.pop()
      
      backtrack(0, [])
      return result
  
  def combinationSum(candidates, target):
      result = []
      
      def backtrack(start, path, remaining):
          if remaining == 0:
              result.append(path[:])
              return
          if remaining < 0:
              return
          
          for i in range(start, len(candidates)):
              path.append(candidates[i])
              backtrack(i, path, remaining - candidates[i])
              path.pop()
      
      backtrack(0, [], target)
      return result`
              },
              "Permutations": {              complexity: "O(n!)",
                spaceComplexity: "O(n!)",
                difficulty: 1,
                description: "Generates all possible arrangements (permutations) of elements where order matters, using backtracking to systematically try all positions.",
                howItWorks: "For each position, try all unused elements. Use visited set or boolean array to track used elements. Backtrack by removing element and marking as unvisited.",
                whyUseIt: "Explores all possible orderings systematically. Essential for problems where arrangement order matters. Can handle duplicates with proper sorting and skipping.",
                useWhen: "All permutations generation, unique permutations with duplicates, next permutation calculation, arranging sequences, solving anagram problems.",
                keyPoints: "Track used elements with set or boolean array. For duplicates: sort first, skip when current == previous and previous unused. Total permutations = n!",
                codeExample: `def permute(nums):
      result = []
      
      def backtrack(path):
          if len(path) == len(nums):
              result.append(path[:])
              return
          
          for i in range(len(nums)):
              if nums[i] not in path:
                  path.append(nums[i])
                  backtrack(path)
                  path.pop()
      
      backtrack([])
      return result
  
  def permuteUnique(nums):
      nums.sort()
      result = []
      used = [False] * len(nums)
      
      def backtrack(path):
          if len(path) == len(nums):
              result.append(path[:])
              return
          
          for i in range(len(nums)):
              if used[i]:
                  continue
              
              if i > 0 and nums[i] == nums[i-1] and not used[i-1]:
                  continue
              
              used[i] = True
              path.append(nums[i])
              backtrack(path)
              path.pop()
              used[i] = False
      
      backtrack([])
      return result`
              }
            }
          },
          "Constraint Satisfaction Problems": {
            icon: "♛",
            algorithms: {
              "N-Queens & Sudoku": {              complexity: "O(N!)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Solves constraint satisfaction problems by systematically placing elements while checking all constraints and backtracking when violations occur.",
                howItWorks: "Place element, check if all constraints satisfied, recurse to next position. If constraints violated or no solution found, backtrack and try next option.",
                whyUseIt: "Only viable approach for complex constraint problems. Prunes invalid solutions early, avoiding exponential explosion of possibilities.",
                useWhen: "N-Queens problem, Sudoku solving, graph coloring, scheduling with constraints, resource allocation problems.",
                keyPoints: "Check constraints before placing. Use efficient constraint validation. Backtrack immediately when constraint violated. Track state changes for easy rollback.",
                codeExample: `def solveNQueens(n):
      result = []
      board = ['.' * n for _ in range(n)]
      
      def is_safe(row, col):
          for i in range(row):
              if board[i][col] == 'Q':
                  return False
          
          i, j = row - 1, col - 1
          while i >= 0 and j >= 0:
              if board[i][j] == 'Q':
                  return False
              i -= 1
              j -= 1
          
          i, j = row - 1, col + 1
          while i >= 0 and j < n:
              if board[i][j] == 'Q':
                  return False
              i -= 1
              j += 1
          
          return True
      
      def backtrack(row):
          if row == n:
              result.append(board[:])
              return
          
          for col in range(n):
              if is_safe(row, col):
                  board[row] = board[row][:col] + 'Q' + board[row][col+1:]
                  backtrack(row + 1)
                  board[row] = board[row][:col] + '.' + board[row][col+1:]
      
      backtrack(0)
      return result`
              },
              "Word Search & Pattern Matching": {              complexity: "O(N·4^L)",
                spaceComplexity: "O(n*m)",
                difficulty: 2,
                description: "Searches for words or patterns in 2D grids using DFS backtracking to explore all possible paths while avoiding revisiting cells.",
                howItWorks: "Start DFS from each cell, mark current cell as visited, explore 4 directions recursively, backtrack by restoring original cell value when done.",
                whyUseIt: "Systematic exploration of all possible paths without getting stuck in cycles. Backtracking ensures we can explore alternative paths efficiently.",
                useWhen: "Word search in grids, pattern matching in 2D arrays, path finding with revisit constraints, board game implementations.",
                keyPoints: "Mark cells as visited temporarily during DFS. Restore original value when backtracking. Check bounds and character match before recursing. Try all 4 directions.",
                codeExample: `def exist(board, word):
      if not board or not word:
          return False
      
      m, n = len(board), len(board[0])
      
      def dfs(i, j, index):
          if index == len(word):
              return True
          
          if (i < 0 or i >= m or j < 0 or j >= n or 
              board[i][j] != word[index]):
              return False
          
          temp = board[i][j]
          board[i][j] = '#'
          
          found = (dfs(i+1, j, index+1) or 
                  dfs(i-1, j, index+1) or 
                  dfs(i, j+1, index+1) or 
                  dfs(i, j-1, index+1))
          
          board[i][j] = temp
          return found
      
      for i in range(m):
          for j in range(n):
              if board[i][j] == word[0] and dfs(i, j, 0):
                  return True
      
      return False`
              }
            }
          }
        }
      },
      "Intervals": {
        sectionIcon: "📊",
        patternCount: 2,
        subcategories: {
          "Merge & Insert Intervals": {
            icon: "🔀",
            algorithms: {
              "Merge Intervals": {              complexity: "O(n log n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Merges overlapping intervals by sorting them by start time and combining consecutive intervals that overlap into single intervals.",
                howItWorks: "Sort intervals by start time, iterate through sorted list, merge current interval with previous if they overlap (current.start ≤ previous.end).",
                whyUseIt: "Fundamental interval processing technique. Simplifies complex interval problems by consolidating overlapping ranges. Essential for scheduling and resource allocation.",
                useWhen: "Merging overlapping intervals, insert interval problems, meeting room scheduling, interval conflict resolution, calendar management.",
                keyPoints: "Always sort by start time first. Two intervals [a,b] and [c,d] overlap if max(a,c) ≤ min(b,d). Merge by taking min start and max end.",
                codeExample: `def merge(intervals):
      if not intervals:
          return []
      
      intervals.sort(key=lambda x: x[0])
      merged = [intervals[0]]
      
      for current in intervals[1:]:
          last = merged[-1]
          
          if current[0] <= last[1]:
              last[1] = max(last[1], current[1])
          else:
              merged.append(current)
      
      return merged
  
  def insert(intervals, newInterval):
      result = []
      i = 0
      n = len(intervals)
      
      while i < n and intervals[i][1] < newInterval[0]:
          result.append(intervals[i])
          i += 1
      
      while i < n and intervals[i][0] <= newInterval[1]:
          newInterval[0] = min(newInterval[0], intervals[i][0])
          newInterval[1] = max(newInterval[1], intervals[i][1])
          i += 1
      result.append(newInterval)
      
      while i < n:
          result.append(intervals[i])
          i += 1
      
      return result`
              },
              "Meeting Rooms & Scheduling": {              complexity: "O(n log n)",
                spaceComplexity: "O(n)",
                difficulty: 2,
                description: "Optimizes meeting room allocation and scheduling by determining minimum rooms needed or if all meetings can be attended using heap or greedy algorithms.",
                howItWorks: "Sort by start time, use min-heap to track end times of ongoing meetings. For each meeting, remove ended meetings from heap, add current meeting's end time.",
                whyUseIt: "Efficiently solves resource allocation problems. Heap size represents minimum resources needed. Greedy approach works optimally for interval scheduling.",
                useWhen: "Meeting room scheduling, resource allocation, minimum rooms/resources needed, interval scheduling optimization, calendar conflict resolution.",
                keyPoints: "Sort by start time. Use heap to track active meetings. Heap size = rooms needed. For attendance: check if current start ≥ previous end.",
                codeExample: `import heapq
  
  def minMeetingRooms(intervals):
      if not intervals:
          return 0
      
      intervals.sort(key=lambda x: x[0])
      heap = []
      
      for start, end in intervals:
          if heap and heap[0] <= start:
              heapq.heappop(heap)
          
          heapq.heappush(heap, end)
      
      return len(heap)
  
  def canAttendMeetings(intervals):
      intervals.sort(key=lambda x: x[0])
      
      for i in range(1, len(intervals)):
          if intervals[i][0] < intervals[i-1][1]:
              return False
      return True`
              }
            }
          }
        }
      },
      "Bit Manipulation": {
        sectionIcon: "🔢",
        patternCount: 2,
        subcategories: {
          "Bitwise Operations": {
            icon: "⚡",
            algorithms: {
              "Single Number XOR": {              complexity: "O(n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Uses XOR bitwise operation properties to find unique elements, missing numbers, or detect duplicates without extra space.",
                howItWorks: "XOR has useful properties: a ⊕ a = 0, a ⊕ 0 = a, XOR is commutative. When XORing all elements, duplicates cancel out, leaving unique elements.",
                whyUseIt: "Achieves O(1) space complexity vs O(n) hash table approach. Elegant mathematical solution using bit manipulation properties.",
                useWhen: "Single number problems, missing number detection, duplicate detection, finding unique elements with space constraints.",
                keyPoints: "XOR cancels identical numbers. a ⊕ a = 0, a ⊕ 0 = a. Commutative property allows any order. Use for problems with pairs + one unique element.",
                codeExample: `def singleNumber(nums):
      result = 0
      for num in nums:
          result ^= num
      return result
  
  def missingNumber(nums):
      n = len(nums)
      missing = n
      for i, num in enumerate(nums):
          missing ^= i ^ num
      return missing
  
  def hammingWeight(n):
      count = 0
      while n:
          count += 1
          n &= n - 1
      return count
  
  def isPowerOfTwo(n):
      return n > 0 and (n & (n - 1)) == 0`
              },
              "Subset Generation with Bits": {              complexity: "O(n·2^n)",
                spaceComplexity: "O(1)",
                difficulty: 2,
                description: "Generates all possible subsets (power set) of a given set using bit manipulation to represent subset membership efficiently.",
                howItWorks: "Use integers from 0 to 2^n-1, where each bit position indicates whether to include corresponding element. Bit set = include element, bit unset = exclude.",
                whyUseIt: "Elegant mathematical approach using binary representation. More memory efficient than recursive backtracking for subset generation. Natural bit-to-subset mapping.",
                useWhen: "All subsets generation, power set enumeration, subset selection problems, combinatorial optimization with bit representation.",
                keyPoints: "Use (1 << n) for 2^n iterations. Check bit with (mask & (1 << i)). Each number 0 to 2^n-1 represents one unique subset.",
                codeExample: `def subsets(nums):
      n = len(nums)
      result = []
      
      for mask in range(1 << n):
          subset = []
          for i in range(n):
              if mask & (1 << i):
                  subset.append(nums[i])
          result.append(subset)
      
      return result
  
  def grayCode(n):
      result = []
      for i in range(1 << n):
          result.append(i ^ (i >> 1))
      return result`
              }
            }
          }
        }
      },
      "Matrix & 2D Arrays": {
        sectionIcon: "🔲",
        patternCount: 3,
        subcategories: {
          "Matrix Traversal": {
            icon: "🌀",
            algorithms: {
              "Spiral Matrix": {              complexity: "O(m×n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Traverses a 2D matrix in spiral order (right → down → left → up) by maintaining and updating boundary pointers to track visited regions.",
                howItWorks: "Use four boundary pointers (top, bottom, left, right). Traverse current boundary, then shrink boundary inward. Repeat until all elements visited.",
                whyUseIt: "Elegant solution for boundary-based traversal. Systematically covers all elements without revisiting. Foundation for matrix rotation and generation problems.",
                useWhen: "Spiral matrix traversal, matrix rotation, generating spiral matrices, boundary-based matrix operations, print matrix elements in spiral.",
                keyPoints: "Four boundaries: top, bottom, left, right. Traverse order: right → down → left → up. Shrink boundaries after each direction. Check bounds before traversing.",
                codeExample: `def spiralOrder(matrix):
      if not matrix:
          return []
      
      result = []
      top, bottom = 0, len(matrix) - 1
      left, right = 0, len(matrix[0]) - 1
      
      while top <= bottom and left <= right:
          for col in range(left, right + 1):
              result.append(matrix[top][col])
          top += 1
          
          for row in range(top, bottom + 1):
              result.append(matrix[row][right])
          right -= 1
          
          if top <= bottom:
              for col in range(right, left - 1, -1):
                  result.append(matrix[bottom][col])
              bottom -= 1
          
          if left <= right:
              for row in range(bottom, top - 1, -1):
                  result.append(matrix[row][left])
              left += 1
      
      return result
  
  def rotate(matrix):
      n = len(matrix)
      
      for i in range(n):
          for j in range(i, n):
              matrix[i][j], matrix[j][i] = matrix[j][i], matrix[i][j]
      
      for row in matrix:
          row.reverse()`
              }
            }
          },
          "Island & Grid Search Problems": {
            icon: "🏝️",
            algorithms: {
              "Island Problems": {              complexity: "O(m×n)",
                spaceComplexity: "O(1)",
                difficulty: 1,
                description: "Finds connected components (islands) in a 2D grid using DFS or BFS to explore all connected cells with the same value.",
                howItWorks: "Iterate through grid, when unvisited land found, start DFS/BFS to mark entire connected component. Count components or calculate properties.",
                whyUseIt: "Essential graph algorithm adapted for grids. Efficiently finds all connected regions in one pass. Foundation for many grid-based problems.",
                useWhen: "Number of islands, largest island area, island perimeter calculation, surrounding regions with water, connected component analysis.",
                keyPoints: "Mark visited cells to avoid recounting. DFS explores all 4 directions. Can modify grid in-place or use visited set. Count islands or calculate area/perimeter.",
                codeExample: `def numIslands(grid):
      if not grid:
          return 0
      
      rows, cols = len(grid), len(grid[0])
      islands = 0
      
      def dfs(r, c):
          if (r < 0 or r >= rows or c < 0 or c >= cols or 
              grid[r][c] != '1'):
              return
          
          grid[r][c] = '0'
          
          dfs(r + 1, c)
          dfs(r - 1, c)
          dfs(r, c + 1)
          dfs(r, c - 1)
      
      for r in range(rows):
          for c in range(cols):
              if grid[r][c] == '1':
                  dfs(r, c)
                  islands += 1
      
      return islands
  
  def maxAreaOfIsland(grid):
      if not grid:
          return 0
      
      rows, cols = len(grid), len(grid[0])
      max_area = 0
      
      def dfs(r, c):
          if (r < 0 or r >= rows or c < 0 or c >= cols or 
              grid[r][c] != 1):
              return 0
          
          grid[r][c] = 0
          
          return 1 + dfs(r+1, c) + dfs(r-1, c) + dfs(r, c+1) + dfs(r, c-1)
      
      for r in range(rows):
          for c in range(cols):
              if grid[r][c] == 1:
                  max_area = max(max_area, dfs(r, c))
      
      return max_area`
              },
              "Path Finding & Shortest Distance": {              complexity: "O(m×n)",
                spaceComplexity: "O(m*n)",
                difficulty: 2,
                description: "Finds shortest paths in 2D grids or mazes using BFS for unweighted grids or dynamic programming for weighted paths.",
                howItWorks: "BFS guarantees shortest path in unweighted grids by exploring level by level. DP builds optimal solution by considering all possible previous steps.",
                whyUseIt: "BFS finds minimum steps efficiently. DP handles weighted paths and obstacles. Both avoid exponential search through systematic exploration.",
                useWhen: "Shortest path in maze, minimum steps to destination, distance calculations in grids, pathfinding with obstacles, route optimization.",
                keyPoints: "BFS for unweighted (min steps), DP for weighted (min cost). Track visited to avoid cycles. Use queue for BFS, table for DP. Handle obstacles properly.",
                codeExample: `from collections import deque
  
  def shortestPath(grid, start, end):
      if not grid or start == end:
          return 0 if start == end else -1
      
      rows, cols = len(grid), len(grid[0])
      queue = deque([(start[0], start[1], 0)])
      visited = set([tuple(start)])
      
      directions = [(0, 1), (1, 0), (0, -1), (-1, 0)]
      
      while queue:
          r, c, dist = queue.popleft()
          
          if [r, c] == end:
              return dist
          
          for dr, dc in directions:
              nr, nc = r + dr, c + dc
              
              if (0 <= nr < rows and 0 <= nc < cols and 
                  grid[nr][nc] == 0 and (nr, nc) not in visited):
                  visited.add((nr, nc))
                  queue.append((nr, nc, dist + 1))
      
      return -1`
              }
            }
          }
        }
      },
      "System Design Patterns": {
        sectionIcon: "🏗️",
        patternCount: 2,
        subcategories: {
          "Cache & Data Structures": {
            icon: "💾",
            algorithms: {
              "LRU Cache": {
                complexity: "O(1)",
                spaceComplexity: "O(capacity)",
                difficulty: 1,
                description: "Implements a Least Recently Used cache with O(1) get and put operations by combining hash map for fast access and doubly linked list for ordering.",
                howItWorks: "Hash map stores key-to-node mapping for O(1) access. Doubly linked list maintains usage order. Move accessed nodes to head, remove from tail when capacity exceeded.",
                whyUseIt: "Most asked system design question in interviews. Combines two data structures for optimal performance. Essential for understanding cache design principles.",
                useWhen: "Cache implementations, memory management systems, data structure design interviews, LRU eviction policy, web caching systems.",
                keyPoints: "HashMap + Doubly Linked List combination. Head = most recent, Tail = least recent. Dummy head/tail simplify edge cases. O(1) for all operations.",
                codeExample: `class Node:
      def __init__(self, key=0, val=0):
          self.key = key
          self.val = val
          self.prev = None
          self.next = None
  
  class LRUCache:
      def __init__(self, capacity: int):
          self.capacity = capacity
          self.cache = {}
          
          self.head = Node()
          self.tail = Node()
          self.head.next = self.tail
          self.tail.prev = self.head
      
      def _add_node(self, node):
          node.prev = self.head
          node.next = self.head.next
          
          self.head.next.prev = node
          self.head.next = node
      
      def _remove_node(self, node):
          prev_node = node.prev
          next_node = node.next
          
          prev_node.next = next_node
          next_node.prev = prev_node
      
      def _move_to_head(self, node):
          self._remove_node(node)
          self._add_node(node)
      
      def _pop_tail(self):
          last_node = self.tail.prev
          self._remove_node(last_node)
          return last_node
      
      def get(self, key: int) -> int:
          node = self.cache.get(key)
          
          if node:
              self._move_to_head(node)
              return node.val
          
          return -1
      
      def put(self, key: int, value: int) -> None:
          node = self.cache.get(key)
          
          if node:
              node.val = value
              self._move_to_head(node)
          else:
              new_node = Node(key, value)
              
              if len(self.cache) >= self.capacity:
                  tail = self._pop_tail()
                  del self.cache[tail.key]
              
              self.cache[key] = new_node
              self._add_node(new_node)`
              },
              "LFU Cache & Advanced Designs": {              complexity: "O(1)",
                spaceComplexity: "O(capacity)",
                difficulty: 3,
                description: "Implements advanced data structures like LFU Cache, RandomizedSet, and MinStack that require O(1) operations through clever combinations of multiple data structures.",
                howItWorks: "LFU uses frequency tracking with multiple hashmaps. RandomizedSet combines array+hashmap. MinStack uses auxiliary stack for minimums.",
                whyUseIt: "Tests deep understanding of data structure trade-offs. Common in system design interviews. Requires optimal space-time complexity balance.",
                useWhen: "LFU Cache implementation, Insert/Delete/GetRandom O(1), Min Stack design, advanced data structure design questions, frequency-based eviction.",
                keyPoints: "LFU: track frequency with multiple hashmaps. RandomizedSet: array for random access + hashmap for O(1) removal. MinStack: auxiliary stack tracks minimums.",
                codeExample: `class RandomizedSet:
      def __init__(self):
          self.nums = []
          self.pos = {}
      
      def insert(self, val):
          if val in self.pos:
              return False
          self.pos[val] = len(self.nums)
          self.nums.append(val)
          return True
      
      def remove(self, val):
          if val not in self.pos:
              return False
          
          last_elem, idx = self.nums[-1], self.pos[val]
          self.nums[idx], self.pos[last_elem] = last_elem, idx
          self.nums.pop()
          del self.pos[val]
          return True
      
      def getRandom(self):
          import random
          return random.choice(self.nums)`
              }
            }
          }
        }
      },
    "Number Theory & Mathematical Algorithms": {
      sectionIcon: "🔢",
      patternCount: 4,
      subcategories: {
        "Prime Number Algorithms": {
          icon: "🔍",
          algorithms: {
            "Sieve of Eratosthenes": {
              complexity: "O(n log log n)",
              spaceComplexity: "O(n)",
              difficulty: 2,
              description: "Ancient algorithm for finding all prime numbers up to a given limit by iteratively marking composite numbers as multiples of each prime.",
              howItWorks: "Create a list of consecutive integers from 2 to n. Start with the first prime number, 2. Mark all multiples of 2 (except 2 itself) as composite. Find the next unmarked number and repeat until reaching √n.",
              whyUseIt: "Most efficient way to find all primes up to a given limit. Time complexity is nearly linear and much faster than testing each number individually for primality.",
              useWhen: "Finding all primes in a range, cryptography applications, number theory problems, mathematical computations requiring multiple primes.",
              keyPoints: "Only need to check up to √n. Use boolean array for memory efficiency. Can be optimized to only store odd numbers. Ancient algorithm still widely used today.",
              codeExample: `def sieve_of_eratosthenes(n):
    is_prime = [True] * (n + 1)
    is_prime[0] = is_prime[1] = False
    
    for i in range(2, int(n**0.5) + 1):
        if is_prime[i]:
            for j in range(i*i, n + 1, i):
                is_prime[j] = False
    
    return [i for i in range(2, n + 1) if is_prime[i]]`
            },
            "Euclidean Algorithm (GCD)": {
              complexity: "O(log min(a,b))",
              spaceComplexity: "O(1)",
              difficulty: 1,
              description: "Efficient algorithm for finding the greatest common divisor (GCD) of two integers using the principle that gcd(a,b) = gcd(b, a mod b).",
              howItWorks: "Repeatedly apply the division algorithm: divide the larger number by the smaller, then replace the larger with the smaller and the smaller with the remainder. Continue until remainder is 0.",
              whyUseIt: "Fundamental algorithm in number theory with many applications. Very efficient with logarithmic time complexity. Forms basis for extended Euclidean algorithm and modular arithmetic.",
              useWhen: "Finding GCD/LCM, simplifying fractions, cryptography (RSA algorithm), solving Diophantine equations, checking if numbers are coprime.",
              keyPoints: "Works by successive division. Can be implemented recursively or iteratively. Extended version also finds coefficients for Bézout's identity. Ancient algorithm, still optimal today.",
              codeExample: `def gcd(a, b):
    while b:
        a, b = b, a % b
    return a

def gcd_recursive(a, b):
    if b == 0:
        return a
    return gcd_recursive(b, a % b)

def extended_gcd(a, b):
    if a == 0:
        return b, 0, 1
    gcd, x1, y1 = extended_gcd(b % a, a)
    x = y1 - (b // a) * x1
    y = x1
    return gcd, x, y`
            }
          }
        },
        "Fast Arithmetic": {
          icon: "⚡",
          algorithms: {
            "Fast Exponentiation": {
              complexity: "O(log n)",
              spaceComplexity: "O(1)",
              difficulty: 2,
              description: "Efficient algorithm for computing large powers using repeated squaring, reducing O(n) naive exponentiation to O(log n).",
              howItWorks: "Use binary representation of exponent. For each bit, square the current result. If bit is 1, multiply by base. This reduces multiplications from n to log n.",
              whyUseIt: "Essential for cryptography, modular arithmetic, and mathematical computations. Transforms exponential time operations into logarithmic time.",
              useWhen: "Modular exponentiation in RSA, computing large powers, mathematical calculations, competitive programming, number theory problems.",
              keyPoints: "Use binary representation of exponent. Square and multiply technique. Can be combined with modular arithmetic. Iterative version avoids stack overflow.",
              codeExample: `def fast_power(base, exp, mod=None):
    result = 1
    base = base % mod if mod else base
    
    while exp > 0:
        if exp % 2 == 1:
            result = (result * base) % mod if mod else result * base
        exp = exp >> 1
        base = (base * base) % mod if mod else base * base
    
    return result

def power_recursive(base, exp):
    if exp == 0:
        return 1
    if exp % 2 == 0:
        half = power_recursive(base, exp // 2)
        return half * half
    return base * power_recursive(base, exp - 1)`
            }
          }
        }
      }
    },
    "Machine Learning & AI Algorithms": {
      sectionIcon: "🤖",
      patternCount: 2,
      subcategories: {
        "Classification Algorithms": {
          icon: "📊",
          algorithms: {
            "K-Nearest Neighbors (KNN)": {
              complexity: "O(nd)",
              spaceComplexity: "O(n)",
              difficulty: 1,
              description: "Simple classification algorithm that classifies data points based on the majority vote of their k nearest neighbors in the feature space.",
              howItWorks: "Store all training data. For new point, calculate distance to all training points. Find k nearest neighbors. Classify based on majority vote of these neighbors.",
              whyUseIt: "Simple to understand and implement. No assumptions about data distribution. Can be used for both classification and regression. Good baseline algorithm.",
              useWhen: "Small to medium datasets, irregular decision boundaries, when interpretability is important, as baseline algorithm, recommendation systems.",
              keyPoints: "Lazy learning algorithm - no training phase. Performance depends on choice of k and distance metric. Sensitive to curse of dimensionality. Consider feature scaling.",
              codeExample: `import math
from collections import Counter

class KNN:
    def __init__(self, k=3):
        self.k = k
        self.X_train = None
        self.y_train = None
    
    def fit(self, X, y):
        self.X_train = X
        self.y_train = y
    
    def euclidean_distance(self, point1, point2):
        return math.sqrt(sum((p1 - p2) ** 2 for p1, p2 in zip(point1, point2)))
    
    def predict(self, X):
        predictions = []
        for x in X:
            distances = []
            for i, x_train in enumerate(self.X_train):
                dist = self.euclidean_distance(x, x_train)
                distances.append((dist, self.y_train[i]))
            
            # Sort by distance and get k nearest
            distances.sort(key=lambda x: x[0])
            k_nearest = distances[:self.k]
            
            # Majority vote
            k_nearest_labels = [label for _, label in k_nearest]
            most_common = Counter(k_nearest_labels).most_common(1)
            predictions.append(most_common[0][0])
        
                     return predictions`
            }
          }
        },
        "AI Search Algorithms": {
          icon: "🎯",
          algorithms: {
            "A* Algorithm": {
              complexity: "O(b^d)",
              spaceComplexity: "O(b^d)",
              difficulty: 3,
              description: "Informed search algorithm that finds optimal path from start to goal using heuristic function to guide search towards target, combining benefits of Dijkstra's and greedy best-first search.",
              howItWorks: "Use evaluation function f(n) = g(n) + h(n) where g(n) is cost from start to n, h(n) is heuristic estimate from n to goal. Always expand node with lowest f(n) value.",
              whyUseIt: "Optimal pathfinding when heuristic is admissible. More efficient than Dijkstra's by using domain knowledge. Widely used in games, robotics, and navigation systems.",
              useWhen: "Pathfinding in games, robot navigation, route planning, puzzle solving, any scenario where you need optimal path with good performance.",
              keyPoints: "Heuristic must be admissible (never overestimate) for optimality. Manhattan distance for grids, Euclidean for continuous space. Balance between optimality and performance.",
              codeExample: `import heapq

class AStar:
    def __init__(self, grid):
        self.grid = grid
        self.rows = len(grid)
        self.cols = len(grid[0])
    
    def heuristic(self, pos1, pos2):
        # Manhattan distance for grid
        return abs(pos1[0] - pos2[0]) + abs(pos1[1] - pos2[1])
    
    def get_neighbors(self, pos):
        row, col = pos
        neighbors = []
        directions = [(0, 1), (1, 0), (0, -1), (-1, 0)]
        
        for dr, dc in directions:
            new_row, new_col = row + dr, col + dc
            if (0 <= new_row < self.rows and 0 <= new_col < self.cols and 
                self.grid[new_row][new_col] != 1):
                neighbors.append((new_row, new_col))
        
        return neighbors
    
    def find_path(self, start, goal):
        open_set = [(0, start)]
        came_from = {}
        g_score = {start: 0}
        f_score = {start: self.heuristic(start, goal)}
        
        while open_set:
            current_f, current = heapq.heappop(open_set)
            
            if current == goal:
                # Reconstruct path
                path = []
                while current in came_from:
                    path.append(current)
                    current = came_from[current]
                path.append(start)
                return path[::-1]
            
            for neighbor in self.get_neighbors(current):
                tentative_g = g_score[current] + 1
                
                if neighbor not in g_score or tentative_g < g_score[neighbor]:
                    came_from[neighbor] = current
                    g_score[neighbor] = tentative_g
                    f_score[neighbor] = tentative_g + self.heuristic(neighbor, goal)
                    heapq.heappush(open_set, (f_score[neighbor], neighbor))
        
        return None`
            }
          }
        }
      }
    }
  },
    
    // Pattern Recognition Keywords for instant identification
    patternKeywords: {
      title: "🔍 Pattern Recognition Keywords",
      subtitle: "Instant pattern identification",
      description: "Recognize patterns quickly by identifying these keywords in problem statements",
      keywords: {
        "Two Pointers": {
          keywords: "two sum, three sum, sorted array, palindrome, container with water, remove duplicates, merge sorted, closest sum, triplets"
        },
        "Sliding Window": {
          keywords: "subarray, substring, window, longest, minimum size, without repeating, anagram, permutation in string, maximum size, fixed window"
        },
        "Binary Search": {
          keywords: "sorted array, search, find target, logarithmic, rotated sorted, first occurrence, last occurrence, peak element, search matrix"
        },
        "Hash Map/Set": {
          keywords: "frequency, count, seen before, complement, O(1) lookup, duplicate, group anagrams, intersection, cache"
        },
        "Prefix Sum": {
          keywords: "subarray sum, range queries, cumulative sum, multiple queries, constant time range, sum equals K, matrix sum"
        },
        "Kadane's Algorithm": {
          keywords: "maximum subarray, maximum sum, contiguous subarray, maximum product, stock prices, best time to buy"
        },
        "Trie (Prefix Tree)": {
          keywords: "prefix, autocomplete, word search, dictionary, search suggestions, longest common prefix, replace words"
        },
        "Fast & Slow Pointers": {
          keywords: "cycle detection, find middle, linked list cycle, Floyd's algorithm, tortoise and hare, intersection point"
        },
        "Linked List Reversal": {
          keywords: "reverse linked list, reverse in groups, palindrome linked list, reorder list, rotate list, swap nodes"
        },
        "Tree DFS": {
          keywords: "binary tree, path sum, tree depth, diameter, lowest common ancestor, serialize, validate BST, symmetric tree"
        },
        "Tree BFS": {
          keywords: "level order, right side view, zigzag traversal, binary tree level, connect nodes, minimum depth"
        },
        "Graph DFS/BFS": {
          keywords: "connected components, number of islands, surrounded regions, word ladder, shortest path, clone graph"
        },
        "Union-Find": {
          keywords: "connected components, redundant connection, accounts merge, satisfiability, network connectivity, percolation"
        },
        "Topological Sort": {
          keywords: "course schedule, dependencies, ordering, directed acyclic graph, prerequisite, alien dictionary"
        },
        "1D Dynamic Programming": {
          keywords: "climbing stairs, house robber, decode ways, fibonacci, coin change, longest increasing subsequence"
        },
        "2D Grid DP": {
          keywords: "unique paths, minimum path sum, dungeon game, edit distance, longest common subsequence, grid traveler"
        },
        "Knapsack Problems": {
          keywords: "subset sum, partition equal subset, target sum, coin change, unbounded knapsack, combination sum"
        },
        "String DP": {
          keywords: "edit distance, longest common subsequence, palindrome partitioning, word break, regular expression, wildcard matching"
        },
        "Top K Elements": {
          keywords: "kth largest, kth smallest, top k frequent, k closest points, merge k sorted, find median"
        },
        "Sliding Window Maximum": {
          keywords: "sliding window maximum, largest rectangle, monotonic deque, maximum in window, deque operations"
        },
        "Combinations & Subsets": {
          keywords: "generate subsets, combinations, combination sum, generate parentheses, letter combinations, subset sum"
        },
        "Permutations": {
          keywords: "all permutations, next permutation, unique permutations, string permutations, sequence generation"
        },
        "Constraint Satisfaction": {
          keywords: "n-queens, sudoku solver, word search, constraint satisfaction, graph coloring, placement problems"
        },
        "Interval Problems": {
          keywords: "merge intervals, insert interval, meeting rooms, non-overlapping intervals, calendar, scheduling"
        },
        "Bit Operations": {
          keywords: "single number, missing number, power of two, bit counting, XOR, subset generation, bit manipulation"
        },
        "Matrix Traversal": {
          keywords: "spiral matrix, rotate matrix, set matrix zeroes, search matrix, diagonal traverse, boundary traversal"
        },
        "Matrix Search & Islands": {
          keywords: "number of islands, surrounded regions, shortest path in grid, word search in grid, flood fill, connected components"
        },
        "Cache Design": {
          keywords: "LRU cache, LFU cache, design cache, eviction policy, insert delete get random, data structure design"
        },
        "Three Sum": {
          keywords: "three sum, triplets, k-sum problems, duplicate handling, nested pointers, sorted array with three elements"
        },
        "Trapping Rain Water": {
          keywords: "container with water, trapping rain water, histogram, valley between peaks, elevation map, area calculation"
        },
        "Maximum Product Subarray": {
          keywords: "maximum product, subarray product, negative numbers, dynamic programming, kadane variation"
        },
        "Product of Array Except Self": {
          keywords: "prefix product, suffix product, no division, left right products, array transformation"
        },
        "Rotate Array": {
          keywords: "rotate array, circular shift, in-place rotation, reverse algorithm, k positions"
        },
        "Find Duplicate Number": {
          keywords: "find duplicate, cycle detection, Floyd's algorithm, tortoise hare, array with duplicates"
        },
        "Valid Anagram": {
          keywords: "anagram validation, character frequency, string comparison, sorting, hash map counting"
        },
        "Group Anagrams": {
          keywords: "group anagrams, string grouping, character frequency, sorted string, hash map groups"
        },
        "Valid Parentheses": {
          keywords: "parentheses matching, stack validation, bracket matching, balanced parentheses, string validation"
        },
        "Longest Palindromic Substring": {
          keywords: "longest palindrome, substring palindrome, expand around center, manacher's algorithm, palindrome detection"
        },
        "Longest Substring Without Repeating Characters": {
          keywords: "longest substring, no repeating, sliding window, character frequency, unique characters"
        },
        "Merge Sort": {
          keywords: "merge sort, divide conquer, stable sorting, O(n log n), merge algorithm, sorting algorithm"
        },
        "Quick Sort": {
          keywords: "quick sort, partition, pivot, in-place sorting, divide conquer, unstable sort"
        },
        "KMP Algorithm": {
          keywords: "string matching, pattern search, KMP, failure function, text processing, linear time search"
        },
        "Fast & Slow Pointers": {
          keywords: "cycle detection, find middle, linked list cycle, Floyd's algorithm, tortoise and hare, intersection point"
        },
        "Reverse Linked List": {
          keywords: "reverse linked list, iterative reversal, recursive reversal, pointer manipulation, list reversal"
        },
        "Merge Sorted Lists": {
          keywords: "merge lists, sorted merge, two pointers, list merging, sorted sequences"
        },
        "Remove Nth Node from End": {
          keywords: "remove node, nth from end, two pointers, list manipulation, node deletion"
        },
        "Intersection & Palindrome": {
          keywords: "list intersection, palindrome list, linked list palindrome, node intersection, list comparison"
        },
        "Cycle Detection": {
          keywords: "cycle detection, Floyd's algorithm, tortoise hare, loop detection, circular reference"
        },
        "Happy Number (Cycle Detection)": {
          keywords: "happy number, cycle detection, digit sum, infinite loop, mathematical cycle"
        },
        "Binary Tree DFS": {
          keywords: "tree traversal, depth first, inorder preorder postorder, tree navigation, recursive traversal"
        },
        "Binary Tree BFS (Level Order)": {
          keywords: "level order, breadth first, tree levels, queue traversal, tree BFS"
        },
        "BST Validation & Operations": {
          keywords: "validate BST, binary search tree, BST operations, tree validation, search tree properties"
        },
        "Lowest Common Ancestor": {
          keywords: "lowest common ancestor, LCA, tree ancestry, binary tree LCA, ancestor finding"
        },
        "Serialize and Deserialize Tree": {
          keywords: "serialize tree, deserialize tree, tree encoding, tree to string, tree reconstruction"
        },
        "Flood Fill & Clone Graph": {
          keywords: "flood fill, clone graph, graph copying, DFS traversal, connected components"
        },
        "Course Schedule II": {
          keywords: "topological sort, course schedule, dependency resolution, directed graph, ordering"
        },
        "Dijkstra's Algorithm": {
          keywords: "shortest path, Dijkstra, weighted graph, priority queue, single source shortest path"
        },
        "Bellman-Ford Algorithm": {
          keywords: "shortest path, negative weights, Bellman Ford, graph algorithm, distance relaxation"
        },
        "Floyd-Warshall Algorithm": {
          keywords: "all pairs shortest path, Floyd Warshall, dynamic programming, transitive closure"
        },
        "Kruskal's Algorithm": {
          keywords: "minimum spanning tree, Kruskal, union find, MST, edge sorting, greedy algorithm"
        },
        "Prim's Algorithm": {
          keywords: "minimum spanning tree, Prim, priority queue, MST, vertex growing, greedy algorithm"
        },
        "Union-Find (Disjoint Set)": {
          keywords: "union find, disjoint set, path compression, rank optimization, connectivity"
        },
        "Fibonacci Style DP": {
          keywords: "fibonacci DP, bottom up, climbing stairs, house robber, state transition, linear DP"
        },
        "Grid Path Problems": {
          keywords: "grid paths, unique paths, path counting, 2D DP, grid navigation, matrix paths"
        },
        "0/1 Knapsack & Variations": {
          keywords: "knapsack problem, subset sum, partition equal, dynamic programming, optimization"
        },
        "Unbounded Knapsack": {
          keywords: "unbounded knapsack, coin change, unlimited items, complete knapsack, infinite supply"
        },
        "Longest Common Subsequence": {
          keywords: "LCS, longest common subsequence, string matching, sequence alignment, DP strings"
        },
        "Longest Increasing Subsequence": {
          keywords: "LIS, longest increasing, subsequence, binary search optimization, patience sorting"
        },
        "Edit Distance": {
          keywords: "edit distance, Levenshtein, string transformation, minimum operations, string DP"
        },
        "Palindrome DP": {
          keywords: "palindrome partitioning, palindrome subsequence, palindrome DP, string palindromes"
        },
        "Advanced DP (Word Break, Pattern Matching)": {
          keywords: "word break, pattern matching, string segmentation, dictionary matching, advanced DP"
        },
        "K Largest/Smallest Elements": {
          keywords: "kth largest, kth smallest, heap selection, quick select, order statistics"
        },
        "Median of Data Stream": {
          keywords: "running median, data stream, two heaps, online algorithm, streaming data"
        },
        "N-Queens & Sudoku": {
          keywords: "n queens, sudoku solver, constraint satisfaction, backtracking, placement problems"
        },
        "Merge Intervals": {
          keywords: "merge intervals, interval merging, overlapping intervals, time scheduling, interval problems"
        },
        "Meeting Rooms & Scheduling": {
          keywords: "meeting rooms, scheduling, interval conflicts, time management, calendar problems"
        },
        "Single Number XOR": {
          keywords: "single number, XOR properties, bit manipulation, duplicate cancellation, unique element"
        },
        "Subset Generation with Bits": {
          keywords: "bit subsets, subset generation, bit manipulation, power set, binary representation"
        },
        "Spiral Matrix": {
          keywords: "spiral traversal, matrix spiral, boundary traversal, matrix navigation, spiral order"
        },
        "Island Problems": {
          keywords: "number of islands, connected components, matrix traversal, flood fill, 2D grid problems"
        },
        "Path Finding & Shortest Distance": {
          keywords: "shortest path in grid, matrix pathfinding, BFS shortest path, grid navigation, distance calculation"
        },
        "LRU Cache": {
          keywords: "LRU cache, least recently used, cache eviction, hash map linked list, O(1) cache operations"
        },
        "LFU Cache & Advanced Designs": {
          keywords: "LFU cache, least frequently used, frequency tracking, advanced cache, data structure design"
        },
        "Word Search & Pattern Matching": {
          keywords: "word search grid, pattern matching, DFS backtracking, 2D word search, grid traversal"
        },
        "Sieve of Eratosthenes": {
          keywords: "prime numbers, sieve, composite numbers, number theory, primality test, factor, divisibility"
        },
        "Euclidean Algorithm (GCD)": {
          keywords: "greatest common divisor, GCD, LCM, number theory, modular arithmetic, extended euclidean, bezout"
        },
        "Fast Exponentiation": {
          keywords: "modular exponentiation, power calculation, binary exponentiation, fast power, cryptography, RSA"
        },
        "Radix Sort": {
          keywords: "digit sorting, non-comparison sort, counting sort, integer sorting, linear time sort, stable sort"
        },
        "Counting Sort": {
          keywords: "frequency counting, integer range, non-comparison sort, linear sort, stable sort, bucket"
        },
        "K-Nearest Neighbors (KNN)": {
          keywords: "machine learning, classification, nearest neighbors, distance metric, lazy learning, pattern recognition"
        },
        "A* Algorithm": {
          keywords: "pathfinding, heuristic search, shortest path, game AI, navigation, informed search, manhattan distance"
        },
        "Boyer-Moore Algorithm": {
          keywords: "string matching, pattern search, right to left, bad character, good suffix, text editor, grep, advanced search"
        },
        "Z Algorithm": {
          keywords: "string matching, linear time, prefix matching, pattern search, Z array, substring search, text processing"
        },
        "Rabin-Karp Algorithm": {
          keywords: "string matching, rolling hash, hash function, pattern search, multiple pattern, plagiarism detection, polynomial hash"
        },
        "Manacher's Algorithm": {
          keywords: "palindrome detection, linear time palindrome, all palindromes, longest palindrome, center expansion, string transformation"
        },
        "Dutch National Flag": {
          keywords: "three way partition, sort colors, 0 1 2 sorting, three pointers, partition algorithm, categorical sorting"
        },
        "Next Permutation": {
          keywords: "lexicographical order, permutation generation, combinatorics, sequence generation, next arrangement, optimization"
        },
        "Moore's Voting Algorithm": {
          keywords: "majority element, voting, candidate selection, linear time, constant space, stream processing, cancellation"
        },
        "Container With Most Water": {
          keywords: "two pointers, area maximization, geometric optimization, water container, height array, greedy approach"
        },
        "First Missing Positive": {
          keywords: "missing number, cyclic sort, constant space, array transformation, hash table simulation, positive integers"
        },
        "Reverse Linked List II": {
          keywords: "partial reversal, linked list, range reversal, pointer manipulation, sublist reversal, between positions"
        },
        "Remove Duplicates": {
          keywords: "duplicate removal, sorted list, linked list, deduplication, unique elements, list processing"
        },
        "Merge k Sorted Lists": {
          keywords: "k way merge, priority queue, heap merge, divide conquer, multiple lists, sorted merge, min heap"
        },
        "Copy List with Random Pointer": {
          keywords: "deep copy, random pointer, linked list cloning, complex structure, interweaving, advanced pointers"
        },
        "Add Two Numbers": {
          keywords: "arithmetic, linked list math, carry propagation, digit addition, number representation, elementary addition"
        },
        "Swap Nodes in Pairs": {
          keywords: "pair swapping, linked list manipulation, systematic swapping, pointer rearrangement, list transformation"
        },
        "Reverse Nodes in k-Group": {
          keywords: "group reversal, k group, batch processing, advanced reversal, systematic transformation, group operations"
        },
        "Counting Sort": {
          keywords: "non comparison sort, integer sorting, frequency counting, linear time sort, stable sort, small range"
        },
        "Radix Sort": {
          keywords: "digit sorting, non comparison sort, stable sort, linear time, counting sort subroutine, multi digit"
        },
        "Bucket Sort": {
          keywords: "bucket distribution, uniform distribution, average linear, floating point, parallelizable, distribution sort"
        },
        "Heap Sort": {
          keywords: "heap data structure, guaranteed O(n log n), in place, binary heap, max heap, priority queue based"
        },
        "Intro Sort": {
          keywords: "hybrid sorting, introspective sort, quicksort heapsort insertion, standard library, adaptive algorithm, guaranteed performance"
        },
        "Tim Sort": {
          keywords: "adaptive sorting, hybrid algorithm, real world data, stable sort, runs, merge insertion, Python Java"
        },
        "Shell Sort": {
          keywords: "gap sequence, insertion sort variant, diminishing gaps, in place, simple implementation, medium arrays"
        },
        "Cocktail Shaker Sort": {
          keywords: "bidirectional bubble, cocktail sort, bubble sort variant, two way bubble, turtle problem, educational"
        },
        "Comb Sort": {
          keywords: "gap bubble sort, shrink factor, bubble sort improvement, gap sequence, turtle elimination, simple"
        },
        "Cycle Sort": {
          keywords: "minimize writes, in place, write optimization, flash memory, database, cycle placement, expensive writes"
        },
        "Pancake Sort": {
          keywords: "flip operations, pancake flipping, spatula sort, prefix reversal, theoretical algorithm, limited operations"
        }
      }
    }
  };
  
// Export for use in React
export default dsaPatterns; 